import { ChangeDetectorRef, Component, NgZone, ViewChild } from '@angular/core';
import { HeaderComponent } from '../../shared/header/header.component';
import { CommonModule } from '@angular/common';
import { CustomButtonComponent } from '../../shared/custom-button/custom-button.component';
import { LocalStorageService } from '../../../services/local-storage/local-storage.service';
import { UserService } from '../../../services/user/user.service';
import { firstValueFrom, interval, Subscription } from 'rxjs';
import { PasswordService } from '../../../services/password/password.service';
import { PasswordDTO } from '../../../interfaces/password-dto';
import { ModalComponent } from '../../shared/modal/modal.component';
import { Router } from '@angular/router';
import {
  HttpTransportType,
  HubConnection,
  HubConnectionBuilder,
  HubConnectionState,
} from '@microsoft/signalr';
import { environment } from '../../../../environments/environment';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ECallCondition } from '../../../enums/e-call-condition.enum';
import { DarkModeService } from '../../../services/dark-mode/dark-mode.service';
import { CookieService } from 'ngx-cookie-service';
import { PatientService } from '../../../services/patient/patient.service';
import { BrandService } from '../../../services/brand/brand.service';
import { parcelaMinima, parcelasDisponiveis as calcularParcelasDisponiveis } from '../../../utils/parcelamento.util';
import { filtrarTerminaisPorTipo, montarTerminalFull, serialInicialPorTipo } from '../../../utils/maquineta.util';
import { fichaLogoHtml, fichaTitulo } from '../../../utils/print-receipt.util';
import { HraInfo } from '../../../interfaces/hra-info';
import { AgendaFilaService } from '../../../services/agenda-fila/agenda-fila.service';
import { AgendaDia } from '../../../interfaces/agenda-dia';
import { detalheAgendaDia } from '../../../utils/agenda-dia-rotulo.util';
import { ADIANT_DESTAQUE_MS, BuscaAdiantamentos, mesclarAdiantamentos } from '../../../utils/adiantamentos-refresh.util';
import { AgendaFilaItem, AgendaFilaResult } from '../../../interfaces/agenda-fila-result';
import { AtendimentoService, CupomAplicadoConta, MotivoExclusaoConta } from '../../../services/atendimento/atendimento.service';
import { Convenio } from '../../../interfaces/convenio';
import { CategoriaConvenio } from '../../../interfaces/categoria-convenio';
import { DadosPagamento, ProcessarPagamentoResult, ItemContaPaciente, CupomDesconto, PacienteBusca, ContaPacienteResumo, AdiantamentoDisponivel, ResumoConclusao, MeuAtendimento } from '../../../interfaces/dados-pagamento';
import { ProcedimentoBusca } from '../../../interfaces/procedimento-busca';
import { OrcamentoGroup, OrcamentoItem } from '../../../interfaces/orcamento-item';
import { DoctorService } from '../../../services/doctor/doctor.service';
import { Doctor } from '../../../interfaces/doctor';
import { matchTcles, urlTcle } from '../../../utils/tcle-map';
import { imprimirTcle, TcleKey } from '../../../utils/tcle-print.util';
import { fatorPesoEscalonado } from '../../../utils/peso-escalonado.util';
import { podeChamarManual as regraChamadaManual } from '../../../utils/chamada-manual.util';
import { GrupoConfig, GRUPOS_DEF } from '../../../constants/grupos-def.const';
import {
  FilaConfig, parseFilaConfig, ordemPadrao, pesoGrupo,
  qualificaGrupo, calcScoreFila, ordenarFilaExibicao, esperaMs, ESCAPE_PADRAO, estourouEspera,
} from '../../../utils/fila-config.util';
import { QueueConfigService } from '../../../services/queue-config/queue-config.service';
import { OperatorSessionService } from '../../../services/operator-session/operator-session.service';
import { AttendanceCycleService } from '../../../services/attendance-cycle/attendance-cycle.service';
import { TimerConfigService } from '../../../services/timer-config/timer-config.service';
import { TimerConfigDto } from '../../../interfaces/timer-config.dto';
import { CountdownTimerComponent, EXPRESS_ALLOWED_REASONS } from './countdown-timer/countdown-timer.component';
import { CashRegisterService } from '../../../services/cash-register/cash-register.service';
import { ManualCallService } from '../../../services/manual-call/manual-call.service';
import { SupervisorService } from '../../../services/supervisor/supervisor.service';
import { PagamentoAvulsoComponent } from '../lancamentos-financeiros/pagamento-avulso/pagamento-avulso.component';
import { CadastroPacienteModalComponent } from '../../shared/cadastro-paciente-modal/cadastro-paciente-modal.component';
import { PagamentoEspecieModalComponent } from '../../shared/pagamento-especie-modal/pagamento-especie-modal.component';
import { AgendaComponent, AgendaFilaMedica, AgendaPacienteFila } from '../agenda/agenda.component';
import { AgendaFiltroEntrada, AgendaVisao, visaoDeAbertura } from '../agenda/agenda-filtro';
import {
  AcaoAtendimentoHistorico, ContaHistorico, HistoricoPacienteComponent, PacienteHistorico,
} from './historico-paciente/historico-paciente.component';
import { PacienteCadastrado } from '../../../services/patient/patient.service';
import { nomeExibicao } from '../../../utils/nome-exibicao.util';
import { MelhorarPlanoSimComponent } from '../abrir-atendimento/melhorar-plano-sim/melhorar-plano-sim.component';
import { RecadosHubService } from '../../../services/recados/recados-hub.service';
import { AdesaoService } from '../../../services/adesao/adesao.service';
import { PlacarVendaCartao } from '../../../interfaces/adesao.dto';
import { VendaCartaoPausaComponent } from './venda-cartao-pausa/venda-cartao-pausa.component';

type TipoAcaoConta = 'cancelar' | 'excluir' | 'trocar' | 'remover-cupom';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    HeaderComponent,
    CustomButtonComponent,
    CommonModule,
    ModalComponent,
    FormsModule,
    ReactiveFormsModule,
    CountdownTimerComponent,
    PagamentoAvulsoComponent,
    CadastroPacienteModalComponent,
    PagamentoEspecieModalComponent,
    AgendaComponent,
    HistoricoPacienteComponent,
    MelhorarPlanoSimComponent,
    VendaCartaoPausaComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  endServiceForm!: FormGroup;

  queueName = {
    all: 'Misto',
    private: 'Particular',
    plans: 'Planos',
  } as any;

  data: any;

  passwords: PasswordDTO[] = [];
  filteredPasswords: PasswordDTO[] = [];
  grupoModo: 'tipo' | 'medico' = 'tipo';

  showMenu: boolean = false;
  isExceededTime: boolean = false;
  isLoading: boolean = false;
  erroCarregarFila = false;
  openToast: boolean = false;
  isBtnBlocked: boolean = false;
  showSpinner: boolean = false;
  filterActive: boolean = false;
  isModalOpen: boolean = false;
  isFinishModalOpen: boolean = false;
  isProfileModalOpen: boolean = false;
  isExpressMotivModalOpen: boolean = false;
  expressGerando: boolean = false;
  expressMotivo: string = '';
  expressCpf: string = '';
  isFinishOptionSelected = false;
  isAdminProfile = false;
  manualCall!: boolean;
  podePriorizarGuiche = false;
  isExpress: boolean = false;

  // ── Produtividade (timer + ciclo) ─────────────────────────────────────────
  @ViewChild(CountdownTimerComponent) timerRef?: CountdownTimerComponent;
  timerConfig: TimerConfigDto = { clinicId: 0, timerSeconds: 5, autoPauseMinutes: 10, autoCallEnabled: true };
  timerActive = false;
  isPaused = false;
  currentPauseReason = '';
  pausedDuration = 0;
  private pauseInterval: any = null;
  isRoundRobinMode = false;
  scoreTooltipDash: { x: number; y: number; groups: { config: GrupoConfig; weight: number; fator: number }[]; total: number } | null = null;
  private _tooltipHideTimer: any = null;

  menuPosition = { top: '0px', left: '0px' };
  elapsedTimes: { [key: number]: string } = {};
  timerSubscriptions: { [key: number]: Subscription } = {};
  delayColor: { [key: number]: string } = {}; // semáforo
  hraMap: { [personId: number]: HraInfo | null } = {};
  // undefined = ainda nao consultado; null = consulta falhou (campo some na ficha).
  private dependentes = new Map<number, boolean | null>();

  /** Lido pela ficha da senha chamada; consulta uma vez por paciente, qualquer que seja o caminho da selecao. */
  dependente(personId: number | null | undefined): boolean | null {
    if (!personId) return null;
    if (!this.dependentes.has(personId)) {
      this.dependentes.set(personId, null);
      this.patientService.ehDependente(personId).then(valor => this.dependentes.set(personId, valor));
    }
    return this.dependentes.get(personId) ?? null;
  }

  initialIndex: number | null = null;
  unitCode!: number;
  isMelhorarPlanoOpen = false;
  finishId!: number;
  ticketId!: number;

  modalMessage!: string;
  modalTitle!: string;
  waitTimeSelected?: string;
  priorityWaitTime!: string;
  userName!: string;
  currentMachine!: string;
  toasterText!: string;
  filter: string = 'all';
  finishStatus = '';

  userProfile: string = '';
  isAdmin = false;
  isPosAtendimento = false;
  supervisorCapaz = false;
  disponivelParaChamadas = false;
  isUnidadeAtendimento = false;

  interval: any;
  intervalTimeOut: any;

  connectionHub: HubConnection | undefined;

  callCondition: ECallCondition = ECallCondition.Geral;
  selectedCallPassword: PasswordDTO | undefined;

  get guicheAtual(): string {
    return '' + (this.localStorageService.get('idTicketWindow') ?? '');
  }
  manualPasswordSelected: PasswordDTO | undefined;

  // Busca paciente (Express → Abrir Atendimento)
  showBuscaPacienteModal = false;
  buscaPacienteQuery = '';
  buscaPacienteResultados: any[] = [];
  isLoadingBuscaPaciente = false;
  buscaPacienteDebounce: any = null;
  private _cachedFilaConfig: FilaConfig | null = null;
  private sortRefreshSub: ReturnType<typeof setInterval> | null = null;

  // ── Sangria ──────────────────────────────────────────────────────────────
  private static readonly LIMITE_SANGRIA = 1000; // bloqueia nos horários agendados
  private static readonly LIMITE_ALERTA   = 200;  // toast de aviso (qualquer momento)
  showSangriaBlock  = false;
  showSangriaToast  = false;
  sangriaAlertSaldo = 0;
  private sangriaTimer:  ReturnType<typeof setTimeout> | null = null;
  private sangriaTimer2: ReturnType<typeof setTimeout> | null = null;

  // Ver Fila modal
  isVerFilaModalOpen = false;
  verFilaAgendas: AgendaDia[] = [];
  verFilaItems: AgendaFilaItem[] = [];
  verFilaTempoMedio: number | null = null;
  verFilaSelectedAgenda: number | null = null;
  verFilaLoading = false;
  verFilaSomenteAguardando = true;
  verFilaRefreshInterval: any = null;
  verFilaDropdownOpen = false;

  // Resultados (pincar) — so Operador
  pincandoResultadoId: number | null = null;

  // Priorizar senha (supervisor/admin)
  priorizarSenha: PasswordDTO | null = null;
  showPriorizarModal = false;
  operadores: { username: string; machine: string }[] = [];
  isLoadingOperadores = false;
  priorizando = false;

  detalheAgenda(a: AgendaDia): string {
    return detalheAgendaDia(a, this.verFilaAgendas);
  }

  get verFilaSelectedAgendaItem(): AgendaDia | null {
    return this.verFilaAgendas.find(a => a.cdAgenda === this.verFilaSelectedAgenda) ?? null;
  }

  // ── Priorizar por guichê + janela ────────────────────────────────────────
  get dentroDaJanela(): boolean {
    const hrInicio = this.timerConfig.hrInicioPriorizar;
    const hrFim = this.timerConfig.hrFimPriorizar;
    if (!hrInicio || !hrFim) return false;
    const now = new Date();
    const hhmm = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    return hhmm >= hrInicio && hhmm <= hrFim;
  }

  get podePriorizarAgora(): boolean {
    return this.isAdmin || (this.podePriorizarGuiche && this.dentroDaJanela);
  }

  selectVerFilaAgenda(cdAgenda: number) {
    this.verFilaDropdownOpen = false;
    this.onAgendaChange(cdAgenda);
  }

  constructor(
    private localStorageService: LocalStorageService,
    private userService: UserService,
    private passwordService: PasswordService,
    private darkModeService: DarkModeService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private patientService: PatientService,
    private agendaFilaService: AgendaFilaService,
    private atendimentoService: AtendimentoService,
    private doctorService: DoctorService,
    private operatorSessionService: OperatorSessionService,
    private attendanceCycleService: AttendanceCycleService,
    private timerConfigService: TimerConfigService,
    private queueConfigService: QueueConfigService,
    private cashRegisterService: CashRegisterService,
    private manualCallService: ManualCallService,
    private supervisorService: SupervisorService,
    private brandService: BrandService,
    private recadosHub: RecadosHubService,
    private adesaoService: AdesaoService,
  ) {
    this.userName = this.localStorageService.get('login');
    // Number() obrigatorio: o login grava currentUnit como STRING desde 2024, e o
    // hub espera long — o SignalR (System.Text.Json) rejeita string em silencio.
    // Era isso que impedia TODO JoinRoundRobin/LeaveRoundRobin/SkipTurn de chegar
    // ao servidor: o rodizio nunca chegou a operar e os guiches caiam no timer.
    this.unitCode = Number(this.localStorageService.get('currentUnit'));
    // Nova rota da fila habilitada em todas as unidades.
    this.isUnidadeAtendimento = true;
    this.ticketId = Number(this.localStorageService.get('idTicketWindow'));
    this.userProfile = this.localStorageService.get('profile');
    this.manualCall = this.localStorageService.get('manualCall');
    this.podePriorizarGuiche = this.localStorageService.get('podePriorizar') === true;
    this.currentMachine = this.userService.getTicketWindow();
    const salva = this.localStorageService.get('selectedPassword');
    // Abrir atendimento sem senha (busca de paciente) grava só {personId, name, cpf}:
    // não é senha em mãos, e tratá-la como tal derrubava o dashboard.
    if (salva && !salva.id) this.localStorageService.remove('selectedPassword');
    else if (salva) {
      this.selectedCallPassword = salva;
      if (this.selectedCallPassword!.dsPassword?.startsWith('EX')) {
        // código feio para verificar se a senha é express (não existe um campo de identificação)
        this.isExpress = true;
      }
    }
  }

  async ngOnInit() {
    this.isAdmin = this.userProfile == 'Administrador' || this.userProfile == 'Supervisor';

    // Pos Atendimento (perfil Tasy 2098): opera de verdade (sessao, ciclo,
    // retomada) mas NUNCA entra na roda/auto-chamada — so chamada manual
    // direta pelo botao, sem precisar armar.
    this.isPosAtendimento = this.userProfile == 'PosAtendimento';

    // Trava do armar vale pelo PERFIL ESCOLHIDO no login (decisao Bruno 27/08):
    // supervisor/admin so chama depois do clique consciente; quem entra como
    // Operador chama automatico direto, seja qual for a conta.
    this.supervisorCapaz = this.isAdmin;

    if (this.isAdmin) {
      this.filter = 'all';
    } else {
      this.filter = this.localStorageService.get('registerQueue');
    }

    this.applyFilter();
    if (!this.isAdmin) this.carregarPlacarAtalhoVc();

    this.endServiceForm = new FormGroup({
      status: new FormControl(true, [Validators.required]),
    });

    await this.loadGroupOrder();
    await this.getPasswords();

    this.openWebSocket();
    this.startTimers();
    this.sortRefreshSub = setInterval(() => this.cdr.detectChanges(), 30000);

    // Sessao e ciclo valem tambem para o supervisor: sem eles o atendimento dele
    // nao entra em metrica nenhuma e a senha nao fecha ao final.
    try {
      if (this.operatorSessionService.sessionId) {
        // Ja existe sessao ativa (ex.: F5/reinicializacao do dashboard):
        // reusa e retoma o ping em vez de criar outra. Evita o churn de
        // sessao, que tirava o guiche do rodizio e exigia deslogar/logar.
        this.operatorSessionService.resumePingIfActive();
      } else {
        await this.operatorSessionService.createSession(
          this.unitCode, this.userName, this.currentMachine, this.ticketId
        );
      }
    } catch { /* não bloqueia */ }
    try {
      this.timerConfig = await this.timerConfigService.getTimerConfig(this.unitCode);
    } catch { /* usa defaults */ }
    try {
      await this.attendanceCycleService.startCycle({
        sessionId: this.operatorSessionService.sessionId ?? 0,
        clinicId: this.unitCode,
        username: this.userName,
        machine: this.currentMachine,
        ticketWindowId: this.ticketId,
      });
    } catch { /* não bloqueia dashboard */ }

    // Depois da sessao criada: e dela que sai o "Online desde" do cabecalho.
    this.carregarStatusOperador();

    // Retomada proativa: se ha senha em atendimento aberto (F5/retorno) e o
    // constructor nao trouxe uma do localStorage, busca no back. So pra quem
    // chama (odonto e admin/supervisor nao chamam automatico).
    if (this.userProfile !== 'OdontoSiM' && !this.isAdmin) {
      try {
        if (!this.selectedCallPassword) {
          const aberta = await this.attendanceCycleService.getOpenPassword(this.unitCode, this.userName);
          if (aberta) {
            this.selectedCallPassword = aberta;
            this.setPasswordData();
            this.timerActive = false;
          }
        }
      } catch { /* não bloqueia dashboard */ }
    }

    // Odonto, supervisor e pos-atendimento nao usam chamada automatica: so manual.
    this.timerActive = this.userProfile !== 'OdontoSiM'
      && !this.isAdmin
      && !this.isPosAtendimento
      && this.chamadasLiberadas
      && this.timerConfig.autoCallEnabled !== false;

    if (!this.isAdmin) {
      this.agendarVerificacaoSangria();
    }

    window.onbeforeunload = () => this.onPageUnload();
  }

  private isNavigatingAway = false;

  private onPageUnload(): void {
    this.isNavigatingAway = true;
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    Object.values(this.timerSubscriptions).forEach((sub) => sub.unsubscribe());
    this.pgBuscaAdiantamentos.parar();
    if (this.pgDestaqueTimer) clearTimeout(this.pgDestaqueTimer);
    clearInterval(this.interval);
    clearInterval(this.verFilaRefreshInterval);
    if (this.sortRefreshSub !== null) clearInterval(this.sortRefreshSub);
    clearInterval(this.pauseInterval);
    this.placarVcPedido++;
    clearTimeout(this.buscaPacienteDebounce);
    if (this._tooltipHideTimer) clearTimeout(this._tooltipHideTimer);

    if (!this.isNavigatingAway) {
      // Navegacao interna: sessao, ciclo e registro na roda SOBREVIVEM (Etapa B).
      // O ping e singleton de app e segue em qualquer tela; o ciclo aberto sera
      // reutilizado pelo get-or-create no retorno. So a trilha registra a saida.
      this.operatorSessionService.notifyNavigation();
    }

    // A conexao do hub morre em TODA saida do dashboard, inclusive navegacao
    // interna, pra nao virar zumbi (conexao antiga viva recebendo CallToken com
    // estado velho — duas instancias chamavam junto no mesmo token, Lapa 19/08:
    // RC1224 e PA4 pela mesma operadora no MESMO segundo). O registro do guiche
    // na roda, porem, NAO sai daqui (LeaveRoundRobin removido): ele persiste no
    // servidor e mantem a posicao; token sem conexao vira skip do watchdog de 30s.
    if (this.connectionHub) this.recadosHub.liberarConexao(this.connectionHub);
    try {
      await Promise.all([
        this.connectionHub?.invoke('Unsubscription', String(this.unitCode)),
        this.connectionHub?.stop(),
      ]);
    } catch {}
    this.connectionHub = undefined;

    if (this.sangriaTimer  !== null) clearTimeout(this.sangriaTimer);
    if (this.sangriaTimer2 !== null) clearTimeout(this.sangriaTimer2);
  }

  // ── Sangria ──────────────────────────────────────────────────────────────

  private getBrasiliaDate(): Date {
    // Converte o momento atual para o fuso de Brasília (America/Sao_Paulo)
    const str = new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
    return new Date(str);
  }

  private async verificarSangria(bloquear: boolean): Promise<void> {
    if (this.isAdmin) return;
    try {
      const caixas = await this.cashRegisterService.getByUnit(this.unitCode, this.userName);
      const saldo = caixas?.[0]?.currentBalance ?? 0;

      this.sangriaAlertSaldo = saldo;

      if (bloquear && saldo > DashboardComponent.LIMITE_SANGRIA) {
        // Horário agendado (11:30 ou 16:30) + caixa acima do limite → bloqueia
        this.showSangriaBlock = true;
        this.showSangriaToast = false;
      } else if (saldo > DashboardComponent.LIMITE_ALERTA) {
        // Acima de R$200 → apenas avisa (nunca bloqueia fora dos horários)
        this.showSangriaToast = true;
      }

      this.cdr.detectChanges();
    } catch { /* silencioso — não bloqueia operação */ }
  }

  private agendarVerificacaoSangria(): void {
    const BLOCO1 = 11 * 60 + 30; // 11:30 Brasília
    const BLOCO2 = 16 * 60 + 30; // 16:30 Brasília

    const now = this.getBrasiliaDate();
    const totalMin = now.getHours() * 60 + now.getMinutes();
    const secOffset = now.getSeconds() * 1000;

    // ── Bloco 1: 11:30 ───────────────────────────────────────────────────
    if (totalMin >= BLOCO1) {
      this.verificarSangria(true); // já passou — verifica imediatamente
    } else {
      const ms = (BLOCO1 - totalMin) * 60_000 - secOffset;
      this.sangriaTimer = setTimeout(() => this.verificarSangria(true), ms);
    }

    // ── Bloco 2: 16:30 ───────────────────────────────────────────────────
    if (totalMin < BLOCO2) {
      const ms = (BLOCO2 - totalMin) * 60_000 - secOffset;
      this.sangriaTimer2 = setTimeout(() => this.verificarSangria(true), ms);
    }
    // Se já passou das 16:30, a verificação imediata do bloco 1 cobre o estado atual
  }

  irParaSangria(): void {
    this.router.navigate(['/lancamentos-financeiros/sangria']);
  }

  // ─────────────────────────────────────────────────────────────────────────

  async onTimerEnd(): Promise<void> {
    if (this.userProfile === 'OdontoSiM') return; // odonto nao chama automatico
    if (this.isRoundRobinMode) {
      this.timerRef?.restart();
      return;
    }
    if (this.expressEmCurso) {
      this.timerRef?.restart();
      return;
    }
    if (!this.selectedCallPassword && this.passwords.length > 0 && !this.isPaused) {
      await this.callNextPassword(false);
    }
    if (!this.selectedCallPassword) {
      this.timerRef?.restart();
    }
  }

  async onTimerPaused(event: { reason: string }): Promise<void> {
    const trocaDeMotivo = this.isPaused;
    this.isPaused = true;
    this.currentPauseReason = event.reason;
    this.carregarPlacarVc();
    if (!trocaDeMotivo) this.iniciarContagemDaPausa();
    try { await this.attendanceCycleService.pause(event.reason); } catch {}
    this.connectionHub?.invoke('LeaveRoundRobin', this.unitCode, this.ticketId)?.catch(() => {});
    if (event.reason === 'Sangria') {
      this.router.navigate(['/lancamentos-financeiros']);
    }
  }

  async onTimerResumed(): Promise<void> {
    this.isPaused = false;
    this.currentPauseReason = '';
    this.placarVcPedido++;
    this.placarVc = null;
    this.carregarPlacarAtalhoVc();
    clearInterval(this.pauseInterval);
    this.pausedDuration = 0;
    try { await this.attendanceCycleService.resume(); } catch {}
    if (this.userProfile !== 'OdontoSiM' && !this.isAdmin && !this.isPosAtendimento && this.chamadasLiberadas) {
      this.connectionHub?.invoke('JoinRoundRobin', this.unitCode, this.ticketId)?.catch(() => {});
    }
  }

  // Troca de motivo com a pausa aberta não reinicia a contagem nem cria um segundo intervalo.
  private iniciarContagemDaPausa(): void {
    this.pausadoDesde = this.formatHoraMinuto(new Date());
    this.filaNoInicioDaPausa = this.countPasswordsNaLista();
    this.pausedDuration = 0;
    clearInterval(this.pauseInterval);
    this.pauseInterval = setInterval(() => this.pausedDuration++, 1000);
  }

  // Na pausa a tela mostra se a fila cresceu e qual a maior espera. Sai da
  // mesma colecao da lista, entao nao inventa numero que a lista nao mostra.
  pausadoDesde: string | null = null;
  filaNoInicioDaPausa = 0;

  get filaCresceuNaPausa(): boolean {
    return this.countPasswordsNaLista() > this.filaNoInicioDaPausa;
  }

  get maiorEsperaNaFilaMin(): number {
    const agora = Date.now();
    const esperas = this.passwordsSortedForDisplay.map(
      p => (agora - new Date(p.passwordGenerationDate).getTime()) / 60000,
    );
    return esperas.length ? Math.floor(Math.max(...esperas)) : 0;
  }

  async onTimerAutoPaused(): Promise<void> {
    const trocaDeMotivo = this.isPaused;
    this.isPaused = true;
    this.currentPauseReason = 'Inatividade automática';
    this.carregarPlacarVc();
    if (!trocaDeMotivo) this.iniciarContagemDaPausa();
    try { await this.attendanceCycleService.pause('Inatividade automática'); } catch {}
    this.connectionHub?.invoke('LeaveRoundRobin', this.unitCode, this.ticketId)?.catch(() => {});
  }

  // A coluna de venda só aparece se o back liberar a unidade (piloto) no placar.
  readonly MOTIVO_VENDA_CARTAO = 'Venda Cartão';
  placarVc: PlacarVendaCartao | null = null;
  private placarVcPedido = 0;

  get emVendaCartao(): boolean {
    return this.isPaused && this.currentPauseReason === this.MOTIVO_VENDA_CARTAO && this.placarVc?.disponivel === true;
  }

  // O motivo pode trocar com o pedido em voo: só vale a resposta do último pedido.
  async carregarPlacarVc(): Promise<void> {
    const pedido = ++this.placarVcPedido;
    if (!this.isPaused || this.currentPauseReason !== this.MOTIVO_VENDA_CARTAO) {
      this.placarVc = null;
      return;
    }
    const placar = await this.adesaoService.placarVendaCartao(this.unitCode);
    if (pedido === this.placarVcPedido) this.placarVc = placar;
  }

  // Atalho da barra: só aparece se o back liberar a venda (piloto + vendedor).
  placarAtalhoVc: PlacarVendaCartao | null = null;

  async carregarPlacarAtalhoVc(): Promise<void> {
    this.placarAtalhoVc = await this.adesaoService.placarVendaCartao(this.unitCode);
  }

  get conversaoAtalhoVc(): number {
    const p = this.placarAtalhoVc;
    return p?.abordagens ? Math.round((p.vendas / p.abordagens) * 100) : 0;
  }

  pausarParaVenda(): void {
    if (this.selectedCallPassword || this.isPaused) return;
    this.timerRef?.pausarCom(this.MOTIVO_VENDA_CARTAO);
  }

  trocarMotivoPausa(): void {
    this.timerRef?.openPauseModal();
  }

  formatPausedDuration(): string {
    const m = Math.floor(this.pausedDuration / 60);
    const s = this.pausedDuration % 60;
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }

  private async loadGroupOrder() {
    try {
      const remote = await this.queueConfigService.getGroupOrder(this.unitCode);
      if (remote) {
        const cfg = parseFilaConfig(remote);
        const validKeys = new Set(GRUPOS_DEF.map(g => g.key));
        if (cfg.order.length && cfg.order.every(k => validKeys.has(k))) {
          this._cachedFilaConfig = cfg;
          localStorage.setItem('gerenciar-fila-order', remote);
          return;
        }
      }
    } catch {}
    this._cachedFilaConfig = { order: ordemPadrao(), weights: {}, escape: { ...ESCAPE_PADRAO } };
  }

  async getPasswords() {
    this.isLoading = true;

    try {
      const response = await this.passwordService.getPasswordQueue(
        this.unitCode,
      );
      const data: PasswordDTO[] = response?.data ?? [];
      this.erroCarregarFila = false;

      const finalizedIdFromService: number | undefined = this.passwordService.getData()?.finalizedId;
      const finalizedIdFromSession = sessionStorage.getItem('finalizedPasswordId');
      const finalizedId: number | undefined = finalizedIdFromService ?? (finalizedIdFromSession ? Number(finalizedIdFromSession) : undefined);
      this.passwordService.clearData();
      sessionStorage.removeItem('finalizedPasswordId');

      this.passwords = data
        .filter(
          (password: PasswordDTO) =>
            this.userProfile !== 'OdontoSiM' ||
            password.specialty.toUpperCase().includes('DENTISTA'),
        )
        .filter((password: PasswordDTO) => !finalizedId || password.id !== finalizedId)
        .map((password: PasswordDTO) => {
          password.priority = password.passwordType
            .toUpperCase()
            .includes('PRIORIDADE');
          return password;
        });

      this.applyFilter();

      if (!this.isSuperClinica) {
        await Promise.all(
          this.passwords.map(async (password) => {
            this.hraMap[password.personId] = await this.patientService.getHraInfo(password.personId);
          })
        );
      }
    } catch (error) {
      this.passwords = [];
      this.applyFilter();
      // handleError do PasswordService troca o erro por texto; o 404 e fila sem senha.
      this.erroCarregarFila = !String(error).startsWith('Not Found');
    } finally {
      this.isLoading = false;
    }
  }

  openWebSocket() {
    const options = {
      // WebSocket direto (skipNegotiation): evita o POST /hub/negotiate, que
      // falhava por CORS preflight cross-origin (Access-Control-Allow-Credentials
      // ausente no back). O fallback de transporte fica desativado; a resiliencia
      // de reconexao (withAutomaticReconnect/onclose/retry abaixo) permanece.
      skipNegotiation: true,
      transport: HttpTransportType.WebSockets,
      accessTokenFactory: () => this.userService.getTokenAuth(),
    };

    const conn = new HubConnectionBuilder()
      .withUrl(environment.hubUrl, options)
      // Reconexao automatica indefinida (tenta a cada 5s, nao desiste).
      .withAutomaticReconnect({ nextRetryDelayInMilliseconds: () => 5000 })
      .build();
    this.connectionHub = conn;

    // Todos os callbacks abaixo checam se ESTA conexao ainda e a atual do
    // componente: apos o ngOnDestroy (que zera connectionHub) ou uma recriacao,
    // uma conexao antiga nao pode se re-inscrever nem se reabrir — era assim
    // que o zumbi renascia 5s depois de morto.
    conn.onreconnected(() => {
      if (this.connectionHub === conn) this.subscribeHub();
    });
    conn.onclose(() => {
      if (this.connectionHub !== conn) return;
      setTimeout(() => { if (this.connectionHub === conn) this.startHub(); }, 5000);
    });

    this.connectionHub.off('Password');
    this.connectionHub.off('AttPassword');
    this.connectionHub.off('RemovePassword');
    this.connectionHub.off('CallToken');

    this.connectionHub.on('Password', (result: any) => {
      if (result) {
        const { data } = JSON.parse(result);
        if (data && data.length > 0) {
          if (
            this.userProfile !== 'OdontoSiM' ||
            (this.userProfile === 'OdontoSiM' &&
              data[0].specialty.toUpperCase().includes('DENTISTA'))
          ) {
            if (!this.passwords.some((p) => p.id === data[0].id)) {
              if (data[0].passwordType.toUpperCase().includes('PRIORIDADE')) {
                data[0].priority = true;
              } else {
                data[0].priority = false;
              }

              this.passwords = [...this.passwords, data[0]];
              this.startTimers();
              if (!this.selectedCallPassword && !this.isPaused && this.timerRef?.remaining === 0) {
                this.timerRef.restart();
              }
              this.cdr.detectChanges();
            }
          }
        }
      }
    });

    this.connectionHub.on('AttPassword', (result: any) => {
      if (!result) return;
      this.ngZone.run(() => {
        const { data } = JSON.parse(result);
        if (data && data.length > 0) {
          const index = this.passwords.findIndex((p) => p.id === data[0].id);
          if (index !== -1) {
            const agendaHoje = data[0].agendaHoje || this.passwords[index].agendaHoje;
            const updated = [...this.passwords];
            updated[index] = { ...updated[index], ...data[0], agendaHoje };
            this.passwords = updated;
          }
          const personId = data[0]?.personId;
          if (personId && !this.isSuperClinica) {
            this.patientService.getHraInfo(personId).then(info => {
              this.hraMap[personId] = info;
            });
          }
        }
      });
    });

    this.connectionHub.on('RemovePassword', (result: any) => {
      if (result) {
        const { data } = JSON.parse(result);
        if (data && data.length > 0) {
          const idToRemove = data[0].id;
          this.passwords = this.passwords.filter((p) => p.id !== idToRemove);
          this.cdr.detectChanges();
        }
      }
    });

    // Round-robin: recebe o token — só chama se for deste guichê
    this.connectionHub.on('CallToken', async (windowId: number) => {
      if (this.userProfile === 'OdontoSiM' || this.isAdmin || this.isPosAtendimento || !this.chamadasLiberadas) {
        // Fora do rodizio: se o token chegou pra este guiche mesmo assim (ex.: outro
        // perfil o registrou antes), libera na hora em vez de engolir e esperar o
        // timeout de 30s a cada volta.
        if (windowId === this.ticketId) {
          this.connectionHub?.invoke('SkipTurn', this.unitCode, this.ticketId)?.catch(() => {});
        }
        return;
      }
      if (windowId !== this.ticketId) return;
      if (this.isPaused || this.selectedCallPassword) {
        // Ocupado (senha em maos) ou pausado: devolve a vez na hora. Antes o token
        // era engolido em silencio e cada guiche ocupado custava 30s de watchdog
        // por volta da roda.
        this.connectionHub?.invoke('SkipTurn', this.unitCode, this.ticketId)?.catch(() => {});
        return;
      }
      if (this.expressEmCurso) {
        // Gerando express: passa a vez em vez de chamar por cima
        this.connectionHub?.invoke('SkipTurn', this.unitCode, this.ticketId)?.catch(() => {});
        return;
      }
      try {
        await this.callNextPassword(false);
      } finally {
        // callNextPassword NAO lanca (trata erro internamente): o sinal de falha
        // (fila vazia pro filtro, 409 etc.) e continuar sem senha em maos. Nesse
        // caso devolve a vez — o back nao libera mais o token no 404.
        if (!this.selectedCallPassword) {
          this.connectionHub?.invoke('SkipTurn', this.unitCode, this.ticketId)?.catch(() => {});
        }
      }
    });

    // Inicia a conexao (com retry) so depois de registrar os handlers.
    this.startHub();
  }

  /** Abre a conexao do hub; em falha, tenta de novo (nao desiste). */
  private startHub(): void {
    if (!this.connectionHub) return;
    if (this.connectionHub.state !== HubConnectionState.Disconnected) return;
    this.connectionHub.start()
      .then(() => this.subscribeHub())
      .catch(() => { setTimeout(() => this.startHub(), 5000); });
  }

  /** Re-inscreve o guichê no grupo da unidade e no rodizio. */
  private subscribeHub(): void {
    if (!this.connectionHub) return;
    this.connectionHub.invoke('Subscription', String(this.unitCode)).catch(() => {});
    this.recadosHub.usarConexao(this.connectionHub).catch(() => {});
    // Odonto, supervisor e pos-atendimento nao entram no rodizio (sem chamada automatica).
    if (this.userProfile === 'OdontoSiM' || this.isAdmin || this.isPosAtendimento || !this.chamadasLiberadas) return;
    this.connectionHub.invoke('JoinRoundRobin', this.unitCode, this.ticketId)
      .then(() => { this.isRoundRobinMode = true; })
      .catch(() => {});
  }

  get passwordsFiltered() {
    return this.passwords;
  }

  percentualGrupo(total: number): number {
    const maior = Math.max(...this.resumoGrupos.map(g => g.total), 1);
    return Math.round((total / maior) * 100);
  }

  // O plano vem da API_PACIENT_PLAN (fonte da verdade). O status do CS_CUSTOMER so existe para o
  // titular B2C: dependente e B2B nao tem, e quem cancelou continua com status.
  temPlano(p: PasswordDTO): boolean {
    if (p.planType) return p.planType !== 'PRIVATE';
    return !!p.subscriptionStatus && p.subscriptionStatus !== 'BLOCKED' && p.subscriptionStatus !== 'CANCELED';
  }

  assinaturaPendente(p: PasswordDTO): boolean {
    return !this.temPlano(p) && p.subscriptionStatus === 'BLOCKED';
  }

  // Sem o isDependent do back, B2C sem cadastro de assinante e dependente (293 de 293 em PROD, 16/10).
  ehDependente(p: PasswordDTO): boolean {
    return !!p.isDependent || (this.temPlano(p) && !p.subscriptionStatus && !!p.planType?.startsWith('B2C'));
  }

  get resumoAssinatura(): { total: number; assinantes: number; pendentes: number; elegiveis: number; pct: number } {
    const lista = this.passwordsFiltered;
    const assinantes = lista.filter(p => this.temPlano(p)).length;
    const pendentes = lista.filter(p => this.assinaturaPendente(p)).length;
    const elegiveis = lista.length - assinantes - pendentes;
    const total = lista.length;
    return { total, assinantes, pendentes, elegiveis, pct: total ? Math.round((assinantes / total) * 100) : 0 };
  }

  get resumoGrupos(): { nome: string; total: number; assinante: number; particular: number }[] {
    const map = new Map<string, { total: number; assinante: number; particular: number }>();
    for (const p of this.passwordsFiltered) {
      const raw = this.grupoModo === 'medico' ? p.agendaHoje : p.specialty;
      const nome = (raw && raw.trim()) ? raw.trim() : (this.grupoModo === 'medico' ? this.semAgenda(p) : 'Sem tipo');
      const g = map.get(nome) ?? { total: 0, assinante: 0, particular: 0 };
      g.total++;
      if (this.temPlano(p)) g.assinante++;
      else g.particular++;
      map.set(nome, g);
    }
    return Array.from(map.entries())
      .map(([nome, g]) => ({ nome, ...g }))
      .sort((a, b) => b.total - a.total);
  }

  setFilter(filter: string) {
    this.filter = filter;
    this.localStorageService.set('filter', this.filter);

    this.applyFilter();
  }

  applyFilter() {
    if (this.filter === 'private') {
      this.filteredPasswords = this.passwords.filter(
        (password) => password.planDescription.toUpperCase() === 'PARTICULAR',
      );
      this.callCondition = ECallCondition.Privado;
    }
    if (this.filter === 'plans') {
      this.filteredPasswords = this.passwords.filter(
        (password) => password.planDescription.toUpperCase() !== 'PARTICULAR',
      );
      this.callCondition = ECallCondition.Plano;
    }
    if (this.filter === 'all') {
      this.filteredPasswords = this.passwords;
      this.callCondition = ECallCondition.Geral;
    }
  }

  startTimers(): void {
    this.passwords.forEach((password) => {
      if (this.timerSubscriptions[password.id]) return;
      const dtPasswordDate = new Date(password.passwordGenerationDate);
      this.timerSubscriptions[password.id] = interval(1000).subscribe(() => {
        const now = new Date();
        const timeDiff = now.getTime() - dtPasswordDate.getTime();
        this.elapsedTimes[password.id] = this.formatTime(timeDiff);

        // Define a cor com base no timeDiff
        const minutesDiff = timeDiff / (1000 * 60); // converte milissegundos para minutos
        if (minutesDiff < 20) {
          this.delayColor[password.id] = 'green';
        } else if (minutesDiff < 30) {
          this.delayColor[password.id] = 'yellow';
        } else {
          this.delayColor[password.id] = 'red';
        }
      });
    });
  }

  formatTime(timeDiff: number): string {
    const absTimeDiff = Math.abs(timeDiff);
    const seconds = Math.floor((absTimeDiff / 1000) % 60);
    const minutes = Math.floor((absTimeDiff / (1000 * 60)) % 60);
    const hours = Math.floor((absTimeDiff / (1000 * 60 * 60)) % 24);

    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  bringScheduleTime(hasSchedule: string, time: Date) {
    if (hasSchedule == 'N') {
      return '-';
    } else {
      const data = new Date(time);
      const horas = String(data.getHours()).padStart(2, '0');
      const minutos = String(data.getMinutes()).padStart(2, '0');
      return `${horas}:${minutos}`;
    }
  }

  onRowClick(event: MouseEvent, password: PasswordDTO) {
    event.stopPropagation();

    this.manualPasswordSelected = password;

    this.renderMenu(event);
  }

  podeChamarManual(password: PasswordDTO | undefined): boolean {
    if (!password) return false;
    return regraChamadaManual({
      calls: password.calls,
      manualCall: this.manualCall,
      isAdmin: this.isAdmin,
      unitCode: this.unitCode,
    });
  }

  renderMenu(event: MouseEvent) {
    if (this.selectedCallPassword && (this.manualCall || this.isAdmin)) {
      this.modalTitle = 'Atenção';
      this.modalMessage = 'Para chamar outra senha, finalize seu atendimento.';
      this.showMenu = false;
      this.manualPasswordSelected = undefined;
      this.isModalOpen = true;
    } else {
      const menuHeight = 150;
      let menuTop = event.clientY - menuHeight;
      // Ajuste caso a posição calculada seja negativa
      if (menuTop < 0) {
        menuTop = 5; // Define uma margem de segurança
      }
      this.menuPosition = { top: `${menuTop}px`, left: `${event.clientX}px` };
      this.showMenu = true;
    }
  }

  isRowSelected(password: PasswordDTO): boolean {
    return String(this.manualPasswordSelected?.id) === String(password.id);
  }

  closeMenu() {
    this.showMenu = false;
  }

  private chamadaEmVoo = false;

  async callNextPassword(showErrorModal = true) {
    if (this.isPaused) return;
    if (this.showSangriaBlock) return;
    if (this.supervisorCapaz && !this.disponivelParaChamadas) {
      this.liberarChamadas();
      return;
    }
    if (this.chamadaEmVoo || this.selectedCallPassword) return;
    this.chamadaEmVoo = true;
    this.isLoading = true;
    try {
      this.selectedCallPassword = await this.passwordService.callNextPassword(
        this.unitCode,
        this.currentMachine,
        this.userName,
        this.ticketId,
        this.callCondition,
      );
      if (this.selectedCallPassword) {
        this.setPasswordData();

        this.userService.changeExpiresAtCookie(
          'token',
          this.selectedCallPassword.inativateDateOperator,
        );

        this.timerActive = false;
        try { await this.attendanceCycleService.markCalled(this.selectedCallPassword.id); } catch {}
      }
    } catch (error: any) {
      if (error?.status === 409 && error?.error?.data?.length) {
        // Ja existe senha em atendimento aberto pra este operador — readota em
        // vez de tratar como erro (Etapa B: navegacao interna nao mata o ciclo).
        this.selectedCallPassword = this.passwordService.mapearDoCustomReturn(error.error);
        this.setPasswordData();
        this.timerActive = false;
        this.modalTitle = 'Atendimento em andamento';
        this.modalMessage = `Você já tem a senha ${this.selectedCallPassword?.dsPassword} em atendimento — ela foi retomada.`;
        this.isModalOpen = true;
        setTimeout(() => (this.isModalOpen = false), 5000);
      } else if (showErrorModal) {
        this.modalTitle = 'Operação abortada';
        this.modalMessage = 'No momento, não há senhas disponíveis para chamada.';
        this.isModalOpen = true;
      }
    } finally {
      this.chamadaEmVoo = false;
      this.passwordsFiltered.map((pf) => (pf.isSelected = false));
      if (this.selectedCallPassword) {
        this.selectedCallPassword!.isSelected = true;
      }
      this.isLoading = false;
      if (this.selectedCallPassword && this.selectedCallPassword.calls < 3) {
        this.setButtonBlockedState(true, 5000);
      } else {
        this.isBtnBlocked = true;
      }
    }
  }

  async callPassword(password: PasswordDTO | undefined) {
    this.isBtnBlocked = true;
    if ((password && password.calls < 3) || (password && this.isExpress)) {
      this.openToast = true;
      clearTimeout(this.intervalTimeOut);
      this.toasterText = this.getToasterText(password.calls);
      this.intervalTimeOut = setTimeout(() => {
        this.openToast = false;
      }, 10000);

      try {
        const response = await this.passwordService.callPassword(
          password.id,
          this.currentMachine,
          password.idQueue,
          password.dsPassword,
          this.userName,
          this.unitCode,
          this.ticketId,
          this.callCondition,
        );

        this.userService.changeExpiresAtCookie(
          'token',
          response.data[0].inativateDateOperator,
        );

        password.calls++;
        this.localStorageService.set(
          'selectedPassword',
          this.selectedCallPassword,
        );

        this.timerActive = false;
        try { await this.attendanceCycleService.markCalled(password.id); } catch {}

        if (password.calls < 3) {
          this.setButtonBlockedState(true, 5000);
        } else {
          this.isBtnBlocked = true;
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  gerenateExpressPassword() {
    this.expressMotivo = '';
    this.expressCpf = '';
    this.isExpressMotivModalOpen = true;
  }

  async confirmExpressPassword(openAttendance = false) {
    if (!this.expressMotivo.trim() || !this.expressCpf.trim()) return;
    if (this.expressGerando || this.selectedCallPassword) return;

    this.expressGerando = true;
    this.isExpressMotivModalOpen = false;

    try {
      (
        await this.passwordService.generateExpressPassword(
          this.userName,
          this.unitCode,
          this.expressMotivo,
        )
      ).subscribe({
        next: (response) => {
          const passwordExpress = response.data[0];
          this.selectedCallPassword = passwordExpress;
          this.localStorageService.set(
            'selectedPassword',
            this.selectedCallPassword,
          );
          this.isExpress = true;
          if (openAttendance) {
            this.buscaPacienteQuery = this.expressCpf.trim();
            this.sendToAbrirAtendimento();
            setTimeout(() => this.onBuscaPacienteInput(), 50);
          }
        },
        error: () => {
          this.expressGerando = false;
          this.modalTitle = 'Atenção';
          this.modalMessage = 'Não foi possível gerar senha express.';
          this.isModalOpen = true;
        },
        complete: () => {
          this.expressGerando = false;
        },
      });
    } catch (error) {
      this.expressGerando = false;
      this.modalTitle = 'Atenção';
      this.modalMessage = 'Não foi possível gerar senha express.';
      this.isModalOpen = true;
    }
  }

  getToasterText(callCount: number): string {
    switch (callCount) {
      case 0:
        return 'está sendo chamada.';
      case 1:
        return 'será chamada pela última vez.';
      case 2:
        return 'foi chamada pela última vez.';
      default:
        return '';
    }
  }

  getGreeting(): string {
    const h = new Date().getHours();
    if (h < 12) return 'Bom dia';
    if (h < 18) return 'Boa tarde';
    return 'Boa noite';
  }

  getWaitMinutes(password: PasswordDTO): number {
    if (!password?.passwordGenerationDate) return 0;
    return Math.floor(
      (new Date().getTime() - new Date(password.passwordGenerationDate).getTime()) / 60000
    );
  }

  readonly nomeExibicao = nomeExibicao;

  getFirstName(name: string): string {
    if (!name) return '';
    return name.trim().split(' ')[0];
  }

  setButtonBlockedState(isBlocked: boolean, timeout: number) {
    this.isBtnBlocked = isBlocked;
    this.showSpinner = isBlocked;

    clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.isBtnBlocked = !isBlocked;
      this.showSpinner = !isBlocked;
      clearInterval(this.interval);
    }, timeout);
  }

  async chamarProximaOdonto(): Promise<void> {
    const proxima = this.passwordsSortedForDisplay[0];
    if (!proxima) {
      this.modalTitle = 'Atenção';
      this.modalMessage = 'Não há senhas de odonto na fila.';
      this.isModalOpen = true;
      return;
    }
    this.selectPassword(proxima);
  }

  selectPassword(password: PasswordDTO) {
    this.passwordsFiltered.map((pf) => (pf.isSelected = false));

    password.isSelected = true;

    this.selectedCallPassword = password;
    this.localStorageService.set('selectedPassword', this.selectedCallPassword);

    this.closeMenu();
    this.callPassword(password);
  }

  markAsFav(password: PasswordDTO) {
    const index = this.passwords.findIndex((p) => p.id === password.id);

    if (index !== -1) {
      if (!this.passwords[index].priority) {
        this.passwords[index].priority = true;
        if (this.initialIndex === null) {
          // Guarda o índice inicial ao marcar como favorito pela primeira vez
          this.initialIndex = index;
        }
        const [movedPassword] = this.passwords.splice(index, 1);
        this.passwords.unshift(movedPassword);
      } else {
        this.passwords[index].priority = false;
        if (this.initialIndex !== null) {
          // Move a senha de volta para sua posição inicial
          const [removedPassword] = this.passwords.splice(index, 1);
          this.passwords.splice(this.initialIndex, 0, removedPassword);
        }
        // Reseta o índice inicial
        this.initialIndex = null;
      }
    }

    this.closeMenu();
  }

  formatDate(scheduleDate: Date, code: string) {
    const scheduleTime = new Date(scheduleDate);
    let dateNowISO = this.passwords.find(
      (p) => p.dsPassword === code,
    )?.hourNow!;
    let dateNow = new Date(dateNowISO);
    let diff = scheduleTime.getTime() - dateNow.getTime();
    if (diff > 1000) this.isExceededTime = true;
    const hours = String(scheduleTime.getHours()).padStart(2, '0');
    const minutes = String(scheduleTime.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  closeToast() {
    this.openToast = false;
  }

  isdisabled(): boolean {
    return !this.selectedCallPassword || this.isBtnBlocked;
  }

  disabledButton(): boolean {
    return this.selectedCallPassword !== undefined;
  }

  get allowsExpress(): boolean {
    // Pos Atendimento e Odonto geram express a qualquer momento (nao usam pausa/timer).
    return this.isPosAtendimento || this.userProfile === 'OdontoSiM'
      || EXPRESS_ALLOWED_REASONS.has(this.currentPauseReason);
  }

  // Enquanto a express está sendo escolhida/gerada, nada pode chamar por cima
  get expressEmCurso(): boolean {
    return this.isExpressMotivModalOpen || this.expressGerando;
  }

  // Portao da disponibilidade: quem tem perfil de supervisao entra fora da
  // roda e sem timer; o PRIMEIRO clique no Chamar libera as
  // chamadas (sem caminho de volta) em vez de chamar.
  get chamadasLiberadas(): boolean {
    return !this.supervisorCapaz || this.disponivelParaChamadas;
  }

  // Liga de vez as chamadas para quem tem perfil de supervisao (sem caminho de
  // volta — so logout/pausa, como qualquer operador). O primeiro clique no
  // Chamar cai aqui em vez de chamar.
  private liberarChamadas(): void {
    this.disponivelParaChamadas = true;

    this.modalTitle = 'Chamadas liberadas';
    this.modalMessage = 'Este guichê agora chama pacientes. Clique novamente em Chamar para chamar a próxima senha.';
    this.isModalOpen = true;
    setTimeout(() => (this.isModalOpen = false), 5000);

    if (this.userProfile === 'OdontoSiM' || this.isAdmin) {
      // Perfil admin/supervisor escolhido no login: libera apenas a chamada
      // manual pelo botao — segue fora da roda e sem timer, como hoje.
      return;
    }

    this.timerActive = this.timerConfig.autoCallEnabled !== false;
    this.connectionHub?.invoke('JoinRoundRobin', this.unitCode, this.ticketId)
      ?.then(() => { this.isRoundRobinMode = true; })
      ?.catch(() => {});
  }

  disabledSmartQueueButton(): boolean {
    if (
      (this.queueName[this.filter] == 'Misto' &&
        this.currentMachine.includes('QUIO')) ||
      (this.queueName[this.filter] == 'Misto' &&
        this.currentMachine.includes('SALA')) ||
      this.userProfile == 'OdontoSiM' ||
      this.selectedCallPassword !== undefined
    ) {
      return true;
    } else {
      return false;
    }
  }

  cantCall(password: PasswordDTO | undefined): boolean {
    if (!password) {
      return true;
    }

    if (
      password.calledMachine == this.currentMachine ||
      password.calledMachine == ''
    ) {
      return false;
    }
    return true;
  }

  async finishPassword(password: PasswordDTO | undefined) {
    if (password) {
      this.isFinishOptionSelected = false;
      this.finishId = password.id;
      this.isFinishModalOpen = true;
      this.closeMenu();
    }
  }

  async setPasswordData(update: boolean = false) {
    this.localStorageService.set('selectedPassword', this.selectedCallPassword);

    if (update && this.selectedCallPassword) {
      await this.passwordService.updateDatePassword(
        this.selectedCallPassword!.id,
      );
    }
  }

  openModal() {
    this.isModalOpen = true;
  }

  closeModal(type: string) {
    if (type == 'finish') {
      this.isFinishModalOpen = false;
    } else if (type == 'express') {
      this.isExpressMotivModalOpen = false;
      this.expressMotivo = '';
      this.expressCpf = '';
    } else {
      this.isModalOpen = false;
    }
  }

  selectFinishOption(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = selectElement.value;

    if (selectedValue) {
      this.finishStatus = selectedValue;
    }

    this.isFinishOptionSelected = !!selectedValue;
  }

  async submitPassword() {
    const exec = {
      '1': () => this.handleAttend(0),
      '2': () => this.handleAttend(8),
      '3': () => this.handleAttend(9),
      '4': () => this.sendToLinkPatient(),
    }[this.finishStatus];

    if (exec) await exec();
  }

  async sendToLinkPatient() {
    await this.setPasswordData(true); // True para indicar atualização
    this.router.navigate(['/link-patient']);
  }

  async sendToAbrirAtendimento() {
    await this.setPasswordData(true);
    if (!this.selectedCallPassword?.personId) {
      this.showBuscaPacienteModal = true;
      this.buscaPacienteQuery = '';
      this.buscaPacienteResultados = [];
      return;
    }
    this.router.navigate(['/abrir-atendimento']);
  }

  onBuscaPacienteInput(): void {
    clearTimeout(this.buscaPacienteDebounce);
    const termo = this.buscaPacienteQuery.trim();
    if (termo.length < 3) {
      this.buscaPacienteResultados = [];
      return;
    }
    this.buscaPacienteDebounce = setTimeout(async () => {
      this.isLoadingBuscaPaciente = true;
      try {
        this.buscaPacienteResultados = await this.atendimentoService.buscarPaciente(termo);
      } catch {
        this.buscaPacienteResultados = [];
      } finally {
        this.isLoadingBuscaPaciente = false;
      }
    }, 400);
  }

  // Historico do Paciente: pelo menu abre na busca; pelo "Mais acoes" ja abre no paciente chamado.
  showHistorico = false;
  historicoPaciente: PacienteHistorico | null = null;

  // Agenda no próprio dashboard: sair da tela derrubaria o hub e a sessão do guichê.
  showAgenda = false;
  agendaInicial: AgendaFiltroEntrada | null = null;
  agendaVisaoInicial: AgendaVisao = 'agendas';

  abrirAgenda(inicial: AgendaFiltroEntrada | null = null): void {
    this.agendaInicial = inicial;
    this.agendaVisaoInicial = visaoDeAbertura(inicial);
    this.showAgenda = true;
  }

  /**
   * Modal ou aviso do dashboard aberto com a Agenda: o painel desce para baixo deles (sem fechar) e
   * volta quando somem. Modal novo que possa abrir com a Agenda aberta entra aqui. O spinner
   * (isLoading) fica de fora: piscaria o painel e recarregaria a grade a cada busca da fila.
   */
  get agendaPorBaixo(): boolean {
    return this.showAgenda && (
      (this.isPaused && !this.isAdmin) || this.isModalOpen || this.isFinishModalOpen
      || this.isExpressMotivModalOpen || this.showPriorizarModal || this.showMeusAtendimentosModal
      || this.showDetalhesPacienteModal || this.showBuscaPacienteModal || this.showCadastroPaciente
      || this.showPagamentoAvulsoModal || this.showHistorico || !!this.contaAcao
      || !!this.timerRef?.showPauseModal || this.isVerFilaModalOpen
    );
  }

  /** O mesmo estado da barra de ações, que o painel da Agenda cobre. */
  get chamadaAutomaticaAgenda(): { texto: string; podePausar: boolean } | null {
    if (!this.timerConfig.autoCallEnabled || this.userProfile === 'OdontoSiM' || this.isAdmin) return null;
    const texto = this.isPaused
      ? 'Chamada automática pausada'
      : this.selectedCallPassword
        ? `Em atendimento: ${this.selectedCallPassword.dsPassword}`
        : (this.timerRef?.remaining || 0) > 0 ? 'Fila aberta · aguardando senhas...' : 'Fila aberta · chamando...';
    const podePausar = !this.isPaused && !this.selectedCallPassword;
    // Mesmo objeto enquanto nada muda: um novo a cada checagem dispararia o NG0100.
    const c = this.cacheChamadaAgenda;
    if (!c || c.texto !== texto || c.podePausar !== podePausar) this.cacheChamadaAgenda = { texto, podePausar };
    return this.cacheChamadaAgenda;
  }
  private cacheChamadaAgenda: { texto: string; podePausar: boolean } | null = null;

  // A Agenda continua aberta por baixo da conta e do Histórico (agendaPorBaixo).
  async onAgendaConta(p: AgendaPacienteFila): Promise<void> {
    if (!p.nrAtendimento) { this.onAgendaHistorico(p); return; }
    try {
      await this.onHistoricoConta({ cdPessoaFisica: p.cdPessoaFisica, nome: p.nome, cpf: p.cpf, nrAtendimento: p.nrAtendimento });
    } catch {
      this.onAgendaHistorico(p);
    }
  }

  onAgendaHistorico(p: AgendaPacienteFila): void {
    this.historicoPaciente = { cdPessoaFisica: p.cdPessoaFisica, nome: p.nome, cpf: p.cpf };
    this.mostrarHistorico();
  }

  abrirHistorico(doPacienteChamado: boolean): void {
    const p = this.selectedCallPassword;
    this.historicoPaciente = doPacienteChamado && p?.personId
      ? { cdPessoaFisica: Number(p.personId), nome: p.name ?? '', cpf: p.cpf ?? '' }
      : null;
    this.mostrarHistorico();
  }

  // Pagar/vincular abre a janela de pagamento com o Histórico escondido (pausado) por baixo;
  // toda saída dela volta ao Histórico (voltarAoHistorico), sem passar pela lista de contas.
  historicoPausado = false;
  contasDoHistorico = false;
  historicoContasVersao = 0;
  historicoAvisoContas = '';

  private mostrarHistorico(): void {
    this.historicoAvisoContas = '';
    this.showHistorico = true;
    if (this.supervisorConta === null) {
      this.atendimentoService.isSupervisorConta().then(s => this.supervisorConta = s).catch(() => {});
    }
  }

  fecharHistorico(): void {
    this.showHistorico = false;
    this.historicoAvisoContas = '';
    this.historicoPausado = false;
    this.contasDoHistorico = false;
  }

  async onHistoricoPagar({ paciente, conta }: ContaHistorico, vincular = false): Promise<void> {
    this.historicoAvisoContas = '';
    this.contasDoHistorico = true;
    this.historicoPausado = true;
    this.detalhesPaciente = { cdPessoaFisica: paciente.cdPessoaFisica, nmPessoaFisica: paciente.nome, nrCpf: paciente.cpf };
    this.contaAcaoSucesso = '';
    this.showDetalhesPacienteModal = true;
    // O pagamento começa antes das contas chegarem: pagandoConta já vem preenchida e a lista não aparece.
    await Promise.all([
      vincular ? this.vincularDireto(conta) : this.iniciarPagamento(conta),
      this.recarregarContasPaciente(),
    ]);
  }

  async onHistoricoMenuConta({ ev, conta, paciente }: { ev: MouseEvent; conta: ContaPacienteResumo; paciente: PacienteHistorico }): Promise<void> {
    this.detalhesPaciente = { cdPessoaFisica: paciente.cdPessoaFisica, nmPessoaFisica: paciente.nome, nrCpf: paciente.cpf };
    // Antes de qualquer await: o currentTarget do evento some depois do clique.
    this.abrirMenuConta(ev, conta);
    await this.recarregarContasPaciente();
  }

  voltarAoHistorico(): void {
    this.limparPagamento();
    this.showDetalhesPacienteModal = false;
    this.detalhesPaciente = null;
    this.contasPaciente = [];
    this.contasVisiveis = 5;
    this.contasDoHistorico = false;
    this.historicoPausado = false;
    this.historicoContasVersao++;
  }

  // Janela de contas do paciente pelo "Conta" da Agenda (o Histórico paga sem ela: onHistoricoPagar).
  async onHistoricoContas(p: PacienteHistorico): Promise<void> {
    this.fecharHistorico();
    await this.abrirContasPaciente(p.cdPessoaFisica, p.nome, p.cpf);
  }

  // "Conta" de um atendimento: mesma lista, já entrando no pagamento daquela conta.
  async onHistoricoConta(ev: AcaoAtendimentoHistorico): Promise<void> {
    await this.onHistoricoContas(ev);
    const conta = this.contasPaciente.find(c => c.nrAtendimento === ev.nrAtendimento);
    if (conta) await this.iniciarPagamento(conta);
  }

  onHistoricoFicha(ev: AcaoAtendimentoHistorico): void {
    this.verFichaMeuAtendimento({ nrAtendimento: ev.nrAtendimento, cdPessoaFisica: ev.cdPessoaFisica } as MeuAtendimento);
  }

  get cdEmpresaDaMarca(): string {
    return this.brandService.cdEmpresa ?? '';
  }

  // CPF da senha Express que nao existe no TASY: cadastra e segue como se tivesse achado.
  showCadastroPaciente = false;

  get cpfDaBusca(): string {
    const digitos = (this.buscaPacienteQuery ?? '').replace(/\D/g, '');
    return digitos.length === 11 ? digitos : '';
  }

  async onPacienteCadastrado(paciente: PacienteCadastrado): Promise<void> {
    this.showCadastroPaciente = false;
    await this.selecionarPacienteBusca({
      cdPessoaFisica: paciente.cdPessoaFisica, nmPessoaFisica: paciente.nome, nrCpf: paciente.cpf,
    });
  }

  async selecionarPacienteBusca(paciente: any): Promise<void> {
    // Vincular paciente à senha
    if (this.selectedCallPassword?.id) {
      try {
        await this.passwordService.linkPassword(
          this.userName, 0,
          Number(this.selectedCallPassword.id),
          paciente.cdPessoaFisica,
          Number(this.unitCode), 0, '',
        );
      } catch { /* não bloqueia */ }
    }
    // Atualizar selectedPassword com dados do paciente
    this.selectedCallPassword = {
      ...this.selectedCallPassword,
      personId: paciente.cdPessoaFisica,
      name: paciente.nmPessoaFisica,
      cpf: paciente.nrCpf,
    } as any;
    this.localStorageService.set('selectedPassword', this.selectedCallPassword);
    this.showBuscaPacienteModal = false;
    this.isExpress = false;
    this.router.navigate(['/abrir-atendimento']);
  }

  discardPassword() {
    this.finishId = Number(this.manualPasswordSelected?.id);
    this.finishStatus = '3';
    this.submitPassword();
  }

  async descartarExpress(): Promise<void> {
    if (!this.selectedCallPassword) return;
    this.finishId = this.selectedCallPassword.id;
    await this.handleAttend(9);
  }

  async handleAttend(answered: number) {
    this.showMenu = false;
    this.isLoading = true;
    // Precisa ser lido antes do finally limpar selectedCallPassword: descarte via menu de
    // contexto finaliza outra senha da lista, nao a que esta em maos, e nao deve mexer no ciclo.
    const isSenhaEmMaos = this.selectedCallPassword?.id == this.finishId;
    let success = false;
    try {
      await this.passwordService
        .finishPassword(this.userName, answered, this.finishId, this.unitCode);

      const storedPassword = this.localStorageService.get('selectedPassword');
      if (storedPassword?.id == this.finishId) {
        this.localStorageService.remove('selectedPassword');
      }
      success = true;
    } catch (error) {
      this.isModalOpen = true;
      this.modalTitle = 'Operação abortada';
      this.modalMessage = 'Erro ao finalizar senha.';
    } finally {
      if (this.selectedCallPassword?.id == this.finishId)
        this.selectedCallPassword = undefined;
      if (this.manualPasswordSelected?.id == this.finishId)
        this.manualPasswordSelected = undefined;
      this.isLoading = false;
      this.isFinishModalOpen = false;

      if (success) {
        this.isModalOpen = true;
        this.modalTitle = 'Operação realizada';
        this.modalMessage = 'Senha finalizada com sucesso!';
        this.localStorageService.remove('selectedPassword');
        setTimeout(() => (this.isModalOpen = false), 5000);
        this.isExpress = false;

        if (!this.isAdmin && answered === 0) {
          try { await this.verificarSangria(false); } catch {}
        }
        if (isSenhaEmMaos) {
          const resultCode = answered === 0 ? 'ATENDIDO' : answered === 8 ? 'NAO_ATENDIDO' : 'DESCARTADO';
          try { await this.attendanceCycleService.finish(resultCode); } catch {}
          this.carregarMediaAtendimento();
          try {
            await this.attendanceCycleService.startCycle({
              sessionId: this.operatorSessionService.sessionId ?? 0,
              clinicId: this.unitCode,
              username: this.userName,
              machine: this.currentMachine,
              ticketWindowId: this.ticketId,
            });
          } catch {}
        }
        if (!this.isAdmin && !this.isPosAtendimento) {
          this.timerActive = true;
        }
      }
    }
  }

  get passwordsSortedForDisplay() {
    const visiveis = this.passwordsFiltered
      .filter(p => !p.specialty.toUpperCase().includes('EXPRESS'));
    let sorted = ordenarFilaExibicao(visiveis, this.getDashFilaConfig(), Date.now());

    // reservadas primeiro: o back consulta GetReservaParaChamada antes da query de score
    if (this.isAdmin) {
      sorted = [...sorted].sort((a, b) => (b.reservadaPor ? 1 : 0) - (a.reservadaPor ? 1 : 0));
    }
    return sorted;
  }

  countPasswordsWaiting(): number {
    return this.passwordsSortedForDisplay.filter(
      p => !p.isSelected && !p.calledMachine
    ).length;
  }

  countPasswordPriority(): number {
    return this.passwordsFiltered.filter(
      (password) =>
        password.priority && !password.isSelected && !password.calledMachine,
    ).length;
  }

  countPassword(): number {
    return this.passwordsFiltered.filter(
      (password) =>
        !password.priority &&
        !password.isSelected &&
        !password.calledMachine &&
        !password.specialty.includes('Express'),
    ).length;
  }

  isDarkMode(): boolean {
    return this.darkModeService.isDarkMode();
  }

  // Copia sem alert: o icone vira um check por 1,5s.
  campoCopiado: string | null = null;
  private timerCopiado?: ReturnType<typeof setTimeout>;

  copiarCampo(valor: string, campo: string): void {
    navigator.clipboard.writeText(valor).then(() => {
      this.campoCopiado = campo;
      clearTimeout(this.timerCopiado);
      this.timerCopiado = setTimeout(() => (this.campoCopiado = null), 1500);
    }).catch(() => {});
  }

  copyToClipboard(value: string) {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        alert('CPF copiado para área de transferência');
      })
      .catch((erro) => {
        console.error('Erro ao copiar o CPF: ', erro);
      });
  }

  formatCpf(cpf: string): string {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  shortName(fullName: string | undefined): string {
    if (!fullName) return '';
    const parts = fullName.trim().split(/\s+/);
    if (parts.length <= 2) return fullName;
    return `${parts[0]} ${parts[parts.length - 1]}`;
  }

  infoTitleTooltip(): string {
    if (
      this.queueName[this.filter] == 'Misto' &&
      (this.currentMachine.includes('QUIO') ||
        this.currentMachine.includes('SALA'))
    ) {
      return 'Não é possível usar a Chamada Inteligente configurado em fila mista';
    } else if (this.userProfile == 'OdontoSiM') {
      return 'Não é possível usar a Chamada Inteligente logado como Odonto SiM';
    } else if (!this.chamadasLiberadas) {
      return 'O primeiro clique libera as chamadas neste guichê';
    } else {
      return 'Chama a próxima senha da fila';
    }
  }

  // ── VER FILA ──────────────────────────────────────────────────────────────

  /** Pela Agenda já abre na agenda da grade. */
  async openVerFila(agenda?: AgendaFilaMedica) {
    this.isVerFilaModalOpen = true;
    this.verFilaAgendas = [];
    this.verFilaItems = [];
    this.verFilaTempoMedio = null;
    this.verFilaSelectedAgenda = null;
    this.verFilaLoading = true;

    try {
      const agendas = await this.agendaFilaService.getAgendasDia(this.unitCode, this.userProfile === 'OdontoSiM' ? 98 : undefined);
      this.verFilaAgendas = agendas.sort((a, b) => b.isOnline - a.isOnline);
    } finally {
      this.verFilaLoading = false;
    }

    // Fechado antes da lista chegar: não pode ligar o refresh de um modal que já sumiu.
    if (!agenda || !this.isVerFilaModalOpen) return;
    if (!this.verFilaAgendas.some(a => a.cdAgenda === agenda.cdAgenda)) {
      this.verFilaAgendas = [...this.verFilaAgendas, {
        cdAgenda: agenda.cdAgenda, dsAgenda: agenda.nmAgenda || `Agenda ${agenda.cdAgenda}`, nmMedico: '', qtAgendados: 0, isOnline: 0,
      }];
    }
    await this.onAgendaChange(agenda.cdAgenda);
  }

  closeVerFila() {
    this.isVerFilaModalOpen = false;
    this.verFilaDropdownOpen = false;
    if (this.verFilaRefreshInterval) {
      clearInterval(this.verFilaRefreshInterval);
      this.verFilaRefreshInterval = null;
    }
  }

  async onAgendaChange(cdAgenda: number) {
    if (!cdAgenda) return;
    this.verFilaSelectedAgenda = cdAgenda;
    await this.loadAgendaFila(cdAgenda);
    if (!this.isVerFilaModalOpen) return;

    if (this.verFilaRefreshInterval) clearInterval(this.verFilaRefreshInterval);
    this.verFilaRefreshInterval = setInterval(() => this.loadAgendaFila(cdAgenda), 30000);
  }

  private async loadAgendaFila(cdAgenda: number) {
    this.verFilaLoading = true;
    try {
      const result = await this.agendaFilaService.getAgendaFila(this.unitCode, cdAgenda);
      this.verFilaItems = result.fila;
      this.verFilaTempoMedio = result.tempoMedio;
    } finally {
      this.verFilaLoading = false;
    }
  }

  toggleSomenteAguardando() {
    this.verFilaSomenteAguardando = !this.verFilaSomenteAguardando;
  }

  get verFilaItemsFiltrados(): AgendaFilaItem[] {
    return this.verFilaSomenteAguardando
      ? this.verFilaItems.filter(p => p.situacao !== 'AGENDADO')
      : this.verFilaItems;
  }

  verFilaEsperaEst(posicao: number | null): string {
    if (!this.verFilaTempoMedio || !posicao) return '—';
    const min = posicao * this.verFilaTempoMedio;
    if (min < 60) return `~${min}m`;
    return `~${Math.floor(min / 60)}h${min % 60 ? String(min % 60).padStart(2, '0') + 'm' : ''}`;
  }

  verFilaCountByStatus(status: string): number {
    return this.verFilaItems.filter(p => p.situacao === status).length;
  }

  // ── Resultados (pincar) inline na tabela principal ───────────────────────

  isResultado(p: PasswordDTO): boolean {
    return ['R', 'PEX', 'PREX'].includes((p.verifyLetter || '').toUpperCase());
  }

  async pincarResultado(password: PasswordDTO): Promise<void> {
    if (password.reservadaPor || this.pincandoResultadoId) return;
    this.pincandoResultadoId = password.id;
    try {
      await this.manualCallService.pincar({
        clinicId: Number(this.unitCode),
        nrSeqPacSenhaFila: password.id,
        nmUsuario: this.userName,
        dsLocal: this.currentMachine ?? '',
      });
    } catch {
      // erro tratado/silencioso
    } finally {
      this.pincandoResultadoId = null;
      await this.getPasswords();
    }
  }

  // ── Priorizar senha (supervisor/admin) ──────────────────────────────────────

  async abrirPriorizar(p: PasswordDTO): Promise<void> {
    this.priorizarSenha = p;
    this.closeMenu();
    this.showPriorizarModal = true;
    this.operadores = [];
    this.isLoadingOperadores = true;
    try {
      const data = await this.supervisorService.getLiveStatus(Number(this.unitCode));
      this.operadores = (data ?? [])
        .filter((o: any) => o.username)
        .map((o: any) => ({ username: o.username, machine: o.machine ?? '' }));
    } catch {
      this.operadores = [];
    } finally {
      this.isLoadingOperadores = false;
    }
  }

  fecharPriorizar(): void {
    this.showPriorizarModal = false;
    this.priorizarSenha = null;
  }

  async confirmarPriorizar(modo: 'P' | 'G', alvoUsuario: string): Promise<void> {
    if (!this.priorizarSenha || this.priorizando) return;
    this.priorizando = true;
    try {
      await this.manualCallService.priorizar({
        clinicId: Number(this.unitCode),
        nrSeqPacSenhaFila: this.priorizarSenha.id,
        modo,
        dsLocal: '',
        nmUsuario: modo === 'G' ? this.userName : alvoUsuario,
        callerUsername: this.userName,
      });
    } catch {
    } finally {
      this.priorizando = false;
      this.showPriorizarModal = false;
      this.priorizarSenha = null;
      await this.getPasswords();
    }
  }

  // ── Status do proprio operador (cabecalho e barra de acoes) ─
  // A hora sai da sessao gravada no proprio front. O /supervisor/live nao
  // serve: ele exclui de proposito as contas com perfil de supervisao, e o
  // AvgAttendanceSeconds daquela query e zero fixo — a media vem do
  // attendance-cycle, que le os ciclos do proprio operador no dia.
  onlineDesde: string | null = null;
  mediaAtendimentoSegundos: number | null = null;

  private carregarStatusOperador(): void {
    const inicio = this.operatorSessionService.sessionStartedAt;
    this.onlineDesde = inicio ? this.formatHoraMinuto(inicio) : null;
    this.carregarMediaAtendimento();
  }

  private async carregarMediaAtendimento(): Promise<void> {
    if (this.isAdmin || !this.unitCode || !this.userName) return;
    try {
      this.mediaAtendimentoSegundos =
        await this.attendanceCycleService.getAvgAttendanceSeconds(this.unitCode, this.userName);
    } catch {
      this.mediaAtendimentoSegundos = null;
    }
  }

  private formatHoraMinuto(valor: Date | string): string | null {
    const d = new Date(valor);
    if (isNaN(d.getTime())) return null;
    return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  }

  get mediaAtendimentoFormatada(): string | null {
    const seg = this.mediaAtendimentoSegundos;
    if (!seg || seg <= 0) return null;
    const min = Math.floor(seg / 60);
    return `${min}:${String(Math.round(seg % 60)).padStart(2, '0')}`;
  }

  // Colunas da fila. Texto sempre em minmax(0, Nfr) — largura minima em px numa
  // coluna de texto e o que empurrava GUICHE pra fora do card no supervisor.
  get gridColunasFila(): string {
    // Fracao em toda coluna de texto, nunca max-content: cada linha e um grid
    // proprio, entao largura que depende do conteudo faz uma linha nao alinhar
    // com a outra nem com o cabecalho. Fracao e px sao iguais em todas.
    const cols = ['56px', '84px', 'minmax(0, 6fr)', 'minmax(0, 1fr)'];
    if (!this.isSuperClinica) cols.push('minmax(0, 1.4fr)');
    cols.push('minmax(0, 1.4fr)');
    return cols.join(' ');
  }

  get nomePlano(): string {
    return this.brandService.nomePlano;
  }

  get nomeMarca(): string {
    return this.brandService.nomeMarca;
  }

  // Tag de assinante SiM+ fica fora do perfil Operador (recepcao); os demais perfis veem.
  get mostraTagSimMais(): boolean {
    return this.isAdmin || this.isPosAtendimento || this.userProfile === 'OdontoSiM';
  }

  // Mesma classificacao da fila (fila-config.util): letra PR = 80+, P = 60+, flag priority = demais.
  tagPrioridade(p: PasswordDTO): string | null {
    if (p.verifyLetter === 'PR') return '80+';
    if (p.verifyLetter === 'P') return '60+';
    return p.priority ? 'PRIOR' : null;
  }

  tituloPrioridade(p: PasswordDTO): string {
    const tag = this.tagPrioridade(p);
    return tag === 'PRIOR' ? 'Prioridade legal' : `Prioridade ${tag}`;
  }

  // Segunda linha da celula do paciente: recebe o que era coluna propria. Mesma regra das
  // colunas antigas: tipo e agendamento (agenda = medico) so no Supervisor, medico so no
  // OdontoSiM. O card da senha chamada continua mostrando tudo.
  // agendaHoje vazio com horario marcado e agenda sem medico (exame), nao falta de agendamento.
  semAgenda(p: PasswordDTO): string {
    return p.hasSchedule !== 'N' ? 'Sem médico' : 'Sem agendamento';
  }

  subtituloPaciente(p: PasswordDTO): string {
    const partes: string[] = [];
    if (p.age) partes.push(`${p.age} anos`);
    if (this.isAdmin) {
      if (p.specialty) partes.push(p.specialty);
      partes.push(p.agendaHoje || this.semAgenda(p).toLowerCase());
      if (p.hasSchedule !== 'N') {
        partes.push(`Agendado ${this.bringScheduleTime(p.hasSchedule, p.scheduledTo)}`);
      }
    }
    if (this.userProfile === 'OdontoSiM' && p.nmMedico) partes.push(p.nmMedico);
    return partes.join(' · ');
  }

  // Mesmos cortes do startTimers (20 e 30 min), mas calculados na hora: o
  // delayColor so existe depois do primeiro tick do timer da linha, e ate la
  // a senha aparece na lista sem entrar em faixa nenhuma.
  faixaEspera(p: PasswordDTO): 'green' | 'yellow' | 'red' {
    const min = (Date.now() - new Date(p.passwordGenerationDate).getTime()) / 60000;
    if (min < 20) return 'green';
    if (min < 30) return 'yellow';
    return 'red';
  }

  // Distribuicao de espera: sai da MESMA colecao que alimenta as linhas, senao
  // o contador diverge das senhas visiveis.
  contarPorFaixaEspera(faixa: 'green' | 'yellow' | 'red'): number {
    return this.passwordsSortedForDisplay.filter((p) => this.faixaEspera(p) === faixa).length;
  }

  // Cabecalho da lista: conta as LINHAS VISIVEIS, senao o pill diverge da
  // soma das faixas. O botao de chamada segue com countPasswordsWaiting(),
  // que exclui quem ja esta no guiche — la "aguardando" e outra pergunta.
  countPasswordsNaLista(): number {
    return this.passwordsSortedForDisplay.length;
  }

  // ── Pagamento Avulso embutido ──────────────────────────────
  // Modal em vez de rota: sair do dashboard derruba a conexao do hub e o
  // guiche vira skip do watchdog ate o operador voltar.
  showPagamentoAvulsoModal = false;

  // Pelo "Mais acoes" da senha chamada, Pagamentos ja abre no paciente dela (como o Historico).
  pagamentoPaciente: PacienteBusca | null = null;

  abrirPagamentoAvulso(doPacienteChamado = false): void {
    const p = this.selectedCallPassword;
    this.pagamentoPaciente = doPacienteChamado && p?.personId
      ? { cdPessoaFisica: Number(p.personId), nmPessoaFisica: p.name ?? '', nrCpf: p.cpf ?? '' }
      : null;
    this.showPagamentoAvulsoModal = true;
  }

  onPagamentoAvulsoFechado(motivo: string | null): void {
    this.showPagamentoAvulsoModal = false;
    if (!motivo) return;
    this.modalTitle = 'Pagamento avulso';
    this.modalMessage = motivo;
    this.isModalOpen = true;
  }

  // ── Meus Atendimentos + Modal Detalhes ─────────────────────
  showMeusAtendimentosModal = false;
  meusAtendimentos: MeuAtendimento[] = [];
  isLoadingMeusAtendimentos = false;
  filtroMeusAtendimentos: string = 'todos';

  showDetalhesPacienteModal = false;
  detalhesPaciente: PacienteBusca | null = null;
  contasPaciente: ContaPacienteResumo[] = [];
  contasVisiveis = 5;
  isLoadingContas = false;
  filtroStatusConta: string = 'todos';

  async abrirMeusAtendimentos(): Promise<void> {
    this.showMeusAtendimentosModal = true;
    this.isLoadingMeusAtendimentos = true;
    try {
      this.meusAtendimentos = await this.atendimentoService.getMeusAtendimentos(
        this.userName, Number(this.unitCode));
    } catch {
      this.meusAtendimentos = [];
    } finally {
      this.isLoadingMeusAtendimentos = false;
    }
  }

  fecharMeusAtendimentosModal(): void {
    this.showMeusAtendimentosModal = false;
    this.meusAtendimentos = [];
    this.filtroMeusAtendimentos = 'todos';
  }

  get meusAtendimentosFiltrados(): MeuAtendimento[] {
    if (this.filtroMeusAtendimentos === 'todos') return this.meusAtendimentos;
    if (this.filtroMeusAtendimentos === 'provisorio')
      return this.meusAtendimentos.filter(a => a.statusConta?.toLowerCase().includes('provis'));
    if (this.filtroMeusAtendimentos === 'definitivo')
      return this.meusAtendimentos.filter(a => a.statusConta?.toLowerCase().includes('definit'));
    if (this.filtroMeusAtendimentos === 'definitivo_saldo')
      return this.meusAtendimentos.filter(a => a.statusConta?.toLowerCase().includes('definit') && (a.vlConta - a.vlPago) > 0.01);
    return this.meusAtendimentos;
  }

  contarMeusAtendimentos(filtro: string): number {
    if (filtro === 'todos') return this.meusAtendimentos.length;
    if (filtro === 'provisorio') return this.meusAtendimentos.filter(a => a.statusConta?.toLowerCase().includes('provis')).length;
    if (filtro === 'definitivo') return this.meusAtendimentos.filter(a => a.statusConta?.toLowerCase().includes('definit')).length;
    if (filtro === 'definitivo_saldo') return this.meusAtendimentos.filter(a => a.statusConta?.toLowerCase().includes('definit') && (a.vlConta - a.vlPago) > 0.01).length;
    return 0;
  }

  async selecionarMeuAtendimento(atendimento: MeuAtendimento): Promise<void> {
    this.showMeusAtendimentosModal = false;
    await this.abrirContasPaciente(atendimento.cdPessoaFisica, atendimento.nmPaciente, '');
  }

  /** Abre o modal de contas do paciente na lista (Meus Atendimentos e Agenda). */
  async abrirContasPaciente(cdPessoaFisica: number, nome: string, cpf: string): Promise<void> {
    this.detalhesPaciente = { cdPessoaFisica, nmPessoaFisica: nome, nrCpf: cpf };
    this.pagandoConta = null;
    this.filtroStatusConta = 'todos';
    this.contasVisiveis = 5;
    this.contaAcaoSucesso = '';
    this.showDetalhesPacienteModal = true;
    if (this.supervisorConta === null) {
      this.atendimentoService.isSupervisorConta().then(s => this.supervisorConta = s);
    }
    await this.recarregarContasPaciente();
  }

  private async recarregarContasPaciente(): Promise<void> {
    if (!this.detalhesPaciente) return;
    this.isLoadingContas = true;
    try {
      this.contasPaciente = await this.atendimentoService.getContasPaciente(this.detalhesPaciente.cdPessoaFisica);
    } catch {
      this.contasPaciente = [];
    } finally {
      this.isLoadingContas = false;
    }
  }

  // ── Ações de supervisor na conta (o back confere o perfil 1848/2027) ──
  supervisorConta: boolean | null = null;
  contaMenu: { conta: ContaPacienteResumo; top: number; right: number } | null = null;

  abrirMenuConta(ev: MouseEvent, conta: ContaPacienteResumo): void {
    const r = (ev.currentTarget as HTMLElement).getBoundingClientRect();
    this.contaMenu = { conta, top: r.bottom + 4, right: window.innerWidth - r.right };
  }
  contaAcao: { tipo: TipoAcaoConta; conta: ContaPacienteResumo } | null = null;
  contaAcaoMotivo = '';
  contaAcaoTipoExclusao: 'engano' | 'desistiu' | 'duplicidade' | 'outro' | '' = '';
  contaAcaoContaRef: number | null = null;
  contaAcaoConvenio: number | null = null;
  contaAcaoCategoria: string | null = null;
  contaAcaoConvenios: Convenio[] = [];
  contaAcaoCategorias: CategoriaConvenio[] = [];
  contaAcaoCupons: CupomAplicadoConta[] = [];
  contaAcaoErro = '';
  contaAcaoAvisoCupom = false;
  contaAcaoSucesso = '';
  contaAcaoEnviando = false;
  readonly MIN_JUSTIFICATIVA_OUTRO = 50;

  contaDefinitiva(conta: ContaPacienteResumo): boolean {
    return !!conta.statusConta?.toLowerCase().includes('definit');
  }

  /** Sem título e sem NF, cancelar é só devolver a conta para provisória. */
  rotuloCancelar(conta: ContaPacienteResumo): string {
    return !conta.temTitulo && !conta.temNf ? 'Voltar para provisória' : 'Cancelar conta';
  }

  get contasParaReferencia(): ContaPacienteResumo[] {
    return this.contasPaciente.filter(c => c.nrInternoConta !== this.contaAcao?.conta.nrInternoConta);
  }

  async abrirAcaoConta(tipo: TipoAcaoConta, conta: ContaPacienteResumo): Promise<void> {
    this.contaMenu = null;
    this.contaAcao = { tipo, conta };
    this.contaAcaoMotivo = '';
    this.contaAcaoTipoExclusao = '';
    this.contaAcaoContaRef = null;
    this.contaAcaoConvenio = null;
    this.contaAcaoCategoria = null;
    this.contaAcaoCategorias = [];
    this.contaAcaoCupons = [];
    this.contaAcaoErro = '';
    this.contaAcaoSucesso = '';
    this.contaAcaoAvisoCupom = false;
    if (tipo === 'excluir' || tipo === 'remover-cupom') {
      this.contaAcaoCupons = await this.atendimentoService.getCuponsDaConta(conta.nrInternoConta);
    }
    if (tipo === 'trocar') {
      try { this.contaAcaoConvenios = await this.atendimentoService.getConvenios({ cdEstabelecimento: this.unitCode, nrAtendimento: conta.nrAtendimento }); } catch { this.contaAcaoConvenios = []; }
    }
  }

  fecharAcaoConta(): void {
    if (this.contaAcaoEnviando) return;
    this.contaAcao = null;
  }

  async onContaAcaoConvenioChange(): Promise<void> {
    this.contaAcaoCategoria = null;
    this.contaAcaoCategorias = [];
    if (this.contaAcaoConvenio == null) return;
    try { this.contaAcaoCategorias = await this.atendimentoService.getCategorias(this.contaAcaoConvenio, this.unitCode); } catch { this.contaAcaoCategorias = []; }
  }

  get contaAcaoPronta(): boolean {
    if (!this.contaAcao || this.contaAcaoEnviando) return false;
    const motivo = this.contaAcaoMotivo.trim();
    switch (this.contaAcao.tipo) {
      case 'cancelar': return motivo.length > 0;
      case 'remover-cupom': return true;
      case 'trocar': return this.contaAcaoConvenio != null && !!this.contaAcaoCategoria && motivo.length > 0;
      case 'excluir':
        if (this.contaAcaoTipoExclusao === 'duplicidade') return this.contaAcaoContaRef != null;
        if (this.contaAcaoTipoExclusao === 'outro') return motivo.length >= this.MIN_JUSTIFICATIVA_OUTRO;
        return this.contaAcaoTipoExclusao !== '';
    }
  }

  codigosCupons(cupons: CupomAplicadoConta[]): string {
    return cupons.map(c => c.codCupom).join(', ');
  }

  tituloAcaoConta(acao: { tipo: TipoAcaoConta; conta: ContaPacienteResumo }): string {
    switch (acao.tipo) {
      case 'cancelar': return this.rotuloCancelar(acao.conta);
      case 'excluir': return 'Excluir conta provisória';
      case 'remover-cupom': return 'Remover cupom';
      case 'trocar': return 'Trocar convênio';
    }
  }

  botaoAcaoConta(tipo: TipoAcaoConta): string {
    switch (tipo) {
      case 'cancelar': return 'Confirmar cancelamento';
      case 'excluir': return 'Excluir conta';
      case 'remover-cupom': return 'Remover cupom';
      case 'trocar': return 'Trocar convênio';
    }
  }

  private motivoExclusao(): MotivoExclusaoConta {
    switch (this.contaAcaoTipoExclusao) {
      case 'duplicidade': return { tipo: 'duplicidade', contaRef: this.contaAcaoContaRef! };
      case 'outro': return { tipo: 'outro', justificativa: this.contaAcaoMotivo.trim() };
      case 'desistiu': return { tipo: 'rapido', justificativa: 'Paciente desistiu do atendimento' };
      default: return { tipo: 'rapido', justificativa: 'Conta lançada por engano' };
    }
  }

  async confirmarAcaoConta(): Promise<void> {
    if (!this.contaAcaoPronta || !this.contaAcao) return;
    const { tipo, conta } = this.contaAcao;
    this.contaAcaoEnviando = true;
    this.contaAcaoErro = '';
    try {
      const r = tipo === 'cancelar'
        ? await this.atendimentoService.cancelarConta(conta.nrInternoConta, this.contaAcaoMotivo.trim())
        : tipo === 'remover-cupom'
          ? await this.atendimentoService.removerCupomConta(conta.nrInternoConta)
        : tipo === 'excluir'
          ? await this.atendimentoService.excluirContaProvisoria(conta.nrInternoConta, this.motivoExclusao())
          : await this.atendimentoService.trocarConvenioConta(
              conta.nrInternoConta, this.contaAcaoConvenio!, this.contaAcaoCategoria!, this.contaAcaoMotivo.trim());
      this.contaAcaoEnviando = false;
      this.contaAcao = null;
      if (this.showHistorico && !this.showDetalhesPacienteModal) {
        this.historicoAvisoContas = r.mensagem;
        this.historicoContasVersao++;
        return;
      }
      this.contaAcaoSucesso = r.mensagem;
      this.contaAcaoAvisoCupom = !!r.cuponsNaoReativados?.length;
      await this.recarregarContasPaciente();
    } catch (e: any) {
      this.contaAcaoErro = e?.message ?? 'Não foi possível concluir a ação.';
      if (e?.status === 403) this.supervisorConta = false;
    } finally {
      this.contaAcaoEnviando = false;
    }
  }

  fecharDetalhesPacienteModal(): void {
    if (this.contasDoHistorico) { this.voltarAoHistorico(); return; }
    this.showDetalhesPacienteModal = false;
    this.detalhesPaciente = null;
    this.contasPaciente = [];
    this.contasVisiveis = 5;
  }

  verMaisContas(): void {
    this.contasVisiveis += 10;
  }

  get contasFiltradas(): ContaPacienteResumo[] {
    if (this.filtroStatusConta === 'todos') return this.contasPaciente;
    if (this.filtroStatusConta === 'provisorio')
      return this.contasPaciente.filter(c => !c.statusConta || c.statusConta.toLowerCase().includes('provis'));
    if (this.filtroStatusConta === 'definitivo')
      return this.contasPaciente.filter(c => c.statusConta?.toLowerCase().includes('definit'));
    if (this.filtroStatusConta === 'definitivo_saldo')
      return this.contasPaciente.filter(c => c.statusConta?.toLowerCase().includes('definit') && (c.vlConta - c.vlPago) > 0.01);
    if (this.filtroStatusConta === 'pendente')
      return this.contasPaciente.filter(c => (c.vlConta - c.vlPago) > 0.01);
    return this.contasPaciente;
  }

  get contasExibidas(): ContaPacienteResumo[] {
    return this.contasFiltradas.slice(0, this.contasVisiveis);
  }

  contarStatus(status: string): number {
    if (status === 'todos') return this.contasPaciente.length;
    if (status === 'provisorio') return this.contasPaciente.filter(c => !c.statusConta || c.statusConta.toLowerCase().includes('provis')).length;
    if (status === 'definitivo') return this.contasPaciente.filter(c => c.statusConta?.toLowerCase().includes('definit')).length;
    if (status === 'definitivo_saldo') return this.contasPaciente.filter(c => c.statusConta?.toLowerCase().includes('definit') && (c.vlConta - c.vlPago) > 0.01).length;
    if (status === 'pendente') return this.contasPaciente.filter(c => (c.vlConta - c.vlPago) > 0.01).length;
    return 0;
  }

  formatCurrencyDash(value: number): string {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  // ── PAGAMENTO DE CONTA (dentro do modal de detalhes) ──────────────────────

  pagandoConta: ContaPacienteResumo | null = null;
  pgDados: DadosPagamento | null = null;
  pgLoading = false;
  pgProcessing = false;
  pgResultado: ProcessarPagamentoResult | null = null;
  pgErro = '';
  pgCopiadoCampo = '';

  // Itens da conta
  pgShowItens = false;
  pgEditandoItens = false;
  pgItens: ItemContaPaciente[] = [];
  pgLoadingItens = false;

  // Adicionar procedimento
  pgAdicionandoProc = false;
  pgNovoProcBusca = '';
  pgNovoProcFiltrados: ProcedimentoBusca[] = [];
  pgShowNovoProcDropdown = false;
  pgNovoProcSelecionado: ProcedimentoBusca | null = null;
  pgNovoProcQtd = 1;
  pgIsAdicionandoProc = false;

  // Cupom
  pgShowCupomModal = false;
  pgCupons: CupomDesconto[] = [];
  pgLoadingCupons = false;
  pgAplicandoCupom = false;

  // Maquineta
  pgShowMaquinetaModal = false;
  pgMaquinetaMetodo = 1;
  pgMaquinetaParcelas = 1;
  pgMaquinetaValor = 0;
  pgMaquinetaTerminalTipo = 'V240mPlus';
  pgMaquinetaTerminalNumero = '';
  pgMaquinetaTerminalFull = '';
  pgMaquinetaTerminaisFiltrados: { tipo: string; numero: string; loja: string }[] = [];
  pgShowTerminalDropdown = false;
  pgEnviandoMaquineta = false;
  pgAguardandoMaquineta = false;

  // Orçamento
  pgShowOrcamentoModal = false;
  pgOrcamentoGroups: OrcamentoGroup[] = [];
  pgLoadingOrcamentos = false;
  pgInserindoOrcamento = false;

  // Vincular Adiantamento
  pgShowVincularModal = false;
  pgAdiantamentos: AdiantamentoDisponivel[] = [];
  pgAdiantamentosSelecionados: Set<number> = new Set();
  pgLoadingAdiantamentos = false;
  pgAtualizandoAdiantamentos = false;
  pgAdiantamentosNovos: Set<number> = new Set();
  private pgDestaqueTimer: ReturnType<typeof setTimeout> | null = null;
  readonly pgBuscaAdiantamentos = new BuscaAdiantamentos(
    () => this.pgDados ? this.atendimentoService.getAdiantamentosDisponiveis(this.pgDados.nrInternoConta) : Promise.resolve([]),
    lista => this.pgAplicarAdiantamentos(lista),
  );
  pgVinculando = false;
  pgVincularProgresso = '';
  pgVincularSucesso = false;
  pgVincularResumo: { nrTitulo: string; vlVinculado: number; vlSaldoPendente: number } | null = null;

  // Step 5 — Conclusão
  pgResumo: ResumoConclusao | null = null;
  pgLoadingResumo = false;

  // Médicos (para edição de itens)
  pgTodosMedicos: Doctor[] = [];


  get pgContaDefinitiva(): boolean {
    return !!this.pagandoConta?.statusConta?.toLowerCase().includes('definit');
  }

  pgHasCaixaAccess = false;
  pgShowEspecie = false;

  private async pgVerificarCaixa(): Promise<void> {
    try {
      this.pgHasCaixaAccess = (await this.cashRegisterService.getByUnit(this.unitCode, this.userName)).length > 0;
    } catch {
      this.pgHasCaixaAccess = false;
    }
  }

  // Recarrega a conta: o adiantamento novo faz o "Processar Pagamento" abrir o vincular.
  async pgOnEspecieRegistrado(): Promise<void> {
    await this.pgRecarregarDados();
  }

  async iniciarPagamento(conta: ContaPacienteResumo): Promise<void> {
    this.pgVerificarCaixa();
    this.pagandoConta = conta;
    this.pgDados = null;
    this.pgResultado = null;
    this.pgErro = '';
    this.pgShowItens = true;
    this.pgEditandoItens = !conta.statusConta?.toLowerCase().includes('definit');
    this.pgItens = [];
    this.pgLoading = true;
    try {
      const dados = await this.atendimentoService.getDadosPagamento(
        conta.nrAtendimento, this.detalhesPaciente!.cdPessoaFisica);
      // saiu (ou trocou de conta) antes da resposta
      if (this.pagandoConta !== conta) return;
      this.pgDados = dados;
      // Já carrega itens e médicos automaticamente
      this.pgCarregarItens();
      this.pgCarregarMedicos();
    } catch (e: any) {
      if (this.pagandoConta === conta) this.pgErro = e?.message ?? 'Erro ao carregar dados de pagamento.';
    } finally {
      if (this.pagandoConta === conta || !this.pagandoConta) this.pgLoading = false;
    }
  }

  voltarParaContas(): void {
    if (this.contasDoHistorico) { this.voltarAoHistorico(); return; }
    this.limparPagamento();
    // Recarrega contas (pode ter mudado após pagamento)
    if (this.detalhesPaciente) {
      this.isLoadingContas = true;
      this.atendimentoService.getContasPaciente(this.detalhesPaciente.cdPessoaFisica)
        .then(c => this.contasPaciente = c)
        .catch(() => {})
        .finally(() => this.isLoadingContas = false);
    }
  }

  private limparPagamento(): void {
    this.pgBuscaAdiantamentos.parar();
    this.pgShowVincularModal = false;
    this.pagandoConta = null;
    this.pgDados = null;
    this.pgResultado = null;
    this.pgErro = '';
    this.pgShowItens = false;
    this.pgItens = [];
  }

  private pgVincularCallback: (() => Promise<void>) | null = null;

  async pgProcessarPagamento(): Promise<void> {
    if (this.pgProcessing || !this.pgDados || !this.pagandoConta) return;

    // Conta já tem título: apenas vincular adiantamento (sem gerar título de novo)
    if (this.pgDados.vlAdiantamento > 0 && this.pgDados.nrTituloConta) {
      this.pgVincularCallback = async () => {
        await this.pgCarregarResumo();
      };
      await this.pgAbrirVincularModal();
      return;
    }

    await this.pgExecutarProcessarPagamento();
  }

  private async pgExecutarProcessarPagamento(): Promise<void> {
    if (this.pgProcessing || !this.pgDados || !this.pagandoConta) return;
    this.pgProcessing = true;
    this.pgErro = '';
    try {
      this.pgResultado = await this.atendimentoService.processarPagamento({
        nrInternoConta: this.pgDados.nrInternoConta,
        nrAtendimento: this.pagandoConta.nrAtendimento,
        cdPessoaFisica: this.detalhesPaciente!.cdPessoaFisica,
        cdEstabelecimento: Number(this.unitCode),
        nmUsuario: this.userName,
      });
      await this.pgCarregarResumo();
      // Pós-vincular (opcional, sem callback) igual ao PRE
      if (this.pgResultado.nrTitulo) {
        setTimeout(() => {
          this.pgVincularCallback = null;
          this.pgAbrirVincularModal();
        }, 1000);
      }
    } catch (e: any) {
      this.pgErro = e?.message ?? 'Erro ao processar pagamento.';
    } finally {
      this.pgProcessing = false;
    }
  }

  private async pgCarregarResumo(): Promise<void> {
    if (!this.pagandoConta || !this.pgDados) return;
    this.pgLoadingResumo = true;
    try {
      this.pgResumo = await this.atendimentoService.getResumoConclusao(
        this.pagandoConta.nrAtendimento, this.pgDados.nrInternoConta);
    } catch { /* silencioso */ }
    finally { this.pgLoadingResumo = false; }
  }

  // Itens da conta
  async pgToggleItens(): Promise<void> {
    this.pgShowItens = !this.pgShowItens;
    if (!this.pgShowItens) { this.pgAdicionandoProc = false; return; }
    if (this.pgItens.length === 0) await this.pgCarregarItens();
  }

  private async pgCarregarItens(): Promise<void> {
    if (!this.pgDados) return;
    this.pgLoadingItens = true;
    try {
      this.pgItens = await this.atendimentoService.getItensContaPaciente(this.pgDados.nrInternoConta);
      for (const item of this.pgItens) {
        item.vlUnitario = item.qtProcedimento > 0 ? item.vlProcedimento / item.qtProcedimento : 0;
      }
    } catch { /* silencioso */ }
    finally { this.pgLoadingItens = false; }
  }

  async pgAlterarQtdItem(item: ItemContaPaciente, delta: number): Promise<void> {
    const novaQtd = item.qtProcedimento + delta;
    if (novaQtd < 1) return;
    try {
      await this.atendimentoService.alterarQuantidadeItem(
        item.nrSequencia, novaQtd, this.pgDados!.nrInternoConta, this.userName);
      item.qtProcedimento = novaQtd;
      await this.pgRecarregarDados();
    } catch (e: any) {
      this.pgErro = e?.message ?? 'Erro ao alterar quantidade.';
    }
  }

  async pgRemoverItem(item: ItemContaPaciente): Promise<void> {
    if (!confirm('Tem certeza que deseja remover este item da conta?')) return;
    try {
      await this.atendimentoService.alterarQuantidadeItem(
        item.nrSequencia, 0, this.pgDados!.nrInternoConta, this.userName);
      this.pgItens = this.pgItens.filter(i => i.nrSequencia !== item.nrSequencia);
      await this.pgRecarregarDados();
    } catch (e: any) {
      this.pgErro = e?.message ?? 'Erro ao remover item.';
    }
  }

  // Médico executor nos itens
  async pgCarregarMedicos(): Promise<void> {
    if (this.pgTodosMedicos.length > 0) return;
    try {
      this.pgTodosMedicos = await this.doctorService.getDoctors(this.unitCode);
    } catch { /* silencioso */ }
  }

  pgToggleEditarMedico(item: ItemContaPaciente): void {
    item.editandoMedico = !item.editandoMedico;
    item.medicoBusca = '';
    item.medicosFiltrados = [];
    item.showMedicoDropdown = false;
    if (item.editandoMedico) this.pgCarregarMedicos();
  }

  pgFiltrarMedicosItem(item: ItemContaPaciente): void {
    const termo = (item.medicoBusca ?? '').trim().toLowerCase();
    if (termo.length < 2) { item.medicosFiltrados = []; item.showMedicoDropdown = false; return; }
    item.medicosFiltrados = this.pgTodosMedicos
      .filter(m => m.doctorName?.toLowerCase().includes(termo))
      .slice(0, 10)
      .map(m => ({ cdPessoaFisica: m.doctorId, nmGuerra: m.doctorName, isParceiro: m.isParceiro }));
    item.showMedicoDropdown = item.medicosFiltrados!.length > 0;
  }

  async pgSelecionarMedicoItem(item: ItemContaPaciente, medico: { cdPessoaFisica: number; nmGuerra: string; isParceiro?: boolean }): Promise<void> {
    item.showMedicoDropdown = false;
    item.editandoMedico = false;
    try {
      await this.atendimentoService.alterarMedicoExecutor(item.nrSequencia, medico.cdPessoaFisica, this.userName);
      item.nomeMedico = medico.nmGuerra;
    } catch (e: any) {
      this.pgErro = e?.message ?? 'Erro ao alterar médico.';
    }
  }

  // Adicionar procedimento
  pgAbrirAdicionarProc(): void {
    this.pgShowItens = true;
    this.pgEditandoItens = true;
    this.pgAdicionandoProc = true;
    this.pgNovoProcBusca = '';
    this.pgNovoProcSelecionado = null;
    this.pgNovoProcFiltrados = [];
    this.pgNovoProcQtd = 1;
    if (this.pgItens.length === 0 && this.pgDados) this.pgCarregarItens();
  }

  async pgFiltrarNovoProc(): Promise<void> {
    const termo = this.pgNovoProcBusca.trim();
    if (termo.length < 2) { this.pgNovoProcFiltrados = []; this.pgShowNovoProcDropdown = false; return; }
    // O back resolve o contexto da conta por nrAtendimento; o preço só aparece se o convênio for conhecido.
    try {
      this.pgNovoProcFiltrados = await this.atendimentoService.buscarProcedimentos(termo, {
        cdEstabelecimento: this.unitCode,
        nrAtendimento: this.pgDados?.nrAtendimento ?? null,
      });
      this.pgShowNovoProcDropdown = this.pgNovoProcFiltrados.length > 0;
    } catch { this.pgNovoProcFiltrados = []; }
  }

  pgSelecionarNovoProc(proc: ProcedimentoBusca): void {
    this.pgNovoProcSelecionado = proc;
    this.pgNovoProcBusca = proc.dsProcExame;
    this.pgShowNovoProcDropdown = false;
  }

  pgCancelarAdicionarProc(): void {
    this.pgAdicionandoProc = false;
    this.pgNovoProcSelecionado = null;
    this.pgNovoProcBusca = '';
  }

  async pgConfirmarAdicionarProc(): Promise<void> {
    if (!this.pgNovoProcSelecionado || this.pgIsAdicionandoProc || !this.pagandoConta) return;
    this.pgIsAdicionandoProc = true;
    this.pgErro = '';
    try {
      const atend = this.meusAtendimentos.find(a => a.nrAtendimento === this.pagandoConta!.nrAtendimento);
      await this.atendimentoService.adicionarProcedimentoConta({
        nrAtendimento: this.pagandoConta.nrAtendimento,
        cdPessoaFisica: this.detalhesPaciente!.cdPessoaFisica,
        cdEstabelecimento: Number(this.unitCode),
        cdMedico: atend?.cdMedicoResp ?? 0,
        cdSetorAtendimento: 0,
        cdProcedimento: this.pgNovoProcSelecionado.cdProcedimento,
        nrSequenciaProc: this.pgNovoProcSelecionado.nrSequencia,
        ieOrigemProced: this.pgNovoProcSelecionado.ieOrigemProced ?? 'P',
        quantidade: this.pgNovoProcQtd,
        nmUsuario: this.userName,
      });
      this.pgAdicionandoProc = false;
      this.pgNovoProcSelecionado = null;
      this.pgNovoProcBusca = '';
      await this.pgRecarregarDados();
      await this.pgCarregarItens();
    } catch (e: any) {
      this.pgErro = e?.message ?? 'Erro ao adicionar procedimento.';
    } finally {
      this.pgIsAdicionandoProc = false;
    }
  }

  // Cupom
  async pgAbrirCupomModal(): Promise<void> {
    this.pgShowCupomModal = true;
    this.pgLoadingCupons = true;
    try {
      this.pgCupons = await this.atendimentoService.getCuponsDisponiveis(this.detalhesPaciente!.cdPessoaFisica);
    } catch { this.pgCupons = []; }
    finally { this.pgLoadingCupons = false; }
  }

  async pgAplicarCupom(cupom: CupomDesconto): Promise<void> {
    if (this.pgAplicandoCupom || !this.pgDados || !this.pagandoConta) return;
    this.pgAplicandoCupom = true;
    this.pgErro = '';
    try {
      await this.atendimentoService.aplicarCupom({
        codCupom: cupom.codCupom,
        nrAtendimento: this.pagandoConta.nrAtendimento,
        nrInternoConta: this.pgDados.nrInternoConta,
        nmUsuario: this.userName,
      });
      this.pgShowCupomModal = false;
      await this.pgRecarregarDados();
      await this.pgCarregarItens();
    } catch (e: any) {
      this.pgErro = e?.message ?? 'Erro ao aplicar cupom.';
    } finally {
      this.pgAplicandoCupom = false;
    }
  }

  // Maquineta
  pgAbrirMaquinetaModal(): void {
    this.pgShowMaquinetaModal = true;
    this.pgMaquinetaMetodo = 1;
    this.pgMaquinetaParcelas = 1;
    this.pgMaquinetaValor = this.pgDados?.vlTotalConta || 0;
    this.pgMaquinetaTerminalNumero = '';
    this.pgMaquinetaTerminalFull = '';
    this.pgAguardandoMaquineta = false;
    const saved = localStorage.getItem('adyen_terminal_id');
    if (saved) {
      this.pgMaquinetaTerminalFull = saved;
      const parts = saved.split('-');
      if (parts.length >= 2) {
        this.pgMaquinetaTerminalTipo = parts[0];
        this.pgMaquinetaTerminalNumero = parts.slice(1).join('-');
      }
    }
  }

  get isSuperClinica(): boolean {
    return this.brandService.cdEmpresa === '16';
  }

  get pgParcelasDisponiveis(): number[] {
    return calcularParcelasDisponiveis(this.pgMaquinetaValor, this.isSuperClinica);
  }

  get pgParcelaMinimaAtual(): number {
    return parcelaMinima(this.isSuperClinica);
  }

  pgOnMaquinetaValorChange(): void {
    const max = this.pgParcelasDisponiveis.length;
    if (this.pgMaquinetaParcelas > max) this.pgMaquinetaParcelas = max;
  }

  pgSelecionarTerminalTipo(tipo: string): void {
    this.pgMaquinetaTerminalTipo = tipo;
    this.pgMaquinetaTerminalNumero = serialInicialPorTipo(tipo);
    this.pgMaquinetaTerminalFull = '';
    this.pgFiltrarTerminais();
  }

  pgFiltrarTerminais(): void {
    const termo = this.pgMaquinetaTerminalNumero.trim();
    this.pgMaquinetaTerminaisFiltrados = filtrarTerminaisPorTipo(this.pgMaquinetaTerminalTipo, termo);
    this.pgShowTerminalDropdown = this.pgMaquinetaTerminaisFiltrados.length > 0;
    this.pgMaquinetaTerminalFull = montarTerminalFull(this.pgMaquinetaTerminalTipo, termo);
  }

  pgSelecionarTerminal(t: { tipo: string; numero: string; loja: string }): void {
    this.pgMaquinetaTerminalNumero = t.numero;
    this.pgMaquinetaTerminalFull = `${t.tipo}-${t.numero}`;
    this.pgShowTerminalDropdown = false;
    localStorage.setItem('adyen_terminal_id', this.pgMaquinetaTerminalFull);
  }

  async pgEnviarMaquineta(): Promise<void> {
    if (this.pgEnviandoMaquineta || !this.pgMaquinetaTerminalFull || !this.pgDados || !this.pagandoConta || this.pgMaquinetaValor <= 0) return;
    this.pgEnviandoMaquineta = true;
    this.pgErro = '';
    localStorage.setItem('adyen_terminal_id', this.pgMaquinetaTerminalFull);
    try {
      await this.atendimentoService.cobrarMaquineta({
        metodo: this.pgMaquinetaMetodo,
        valor: this.pgMaquinetaValor,
        parcelas: this.pgMaquinetaParcelas,
        terminal: this.pgMaquinetaTerminalFull,
        descricao: `Atendimento #${this.pagandoConta.nrAtendimento}`,
        patientId: this.detalhesPaciente!.cdPessoaFisica,
        cdEstabelecimento: this.unitCode,
      });
      this.pgAguardandoMaquineta = true;
    } catch (e: any) {
      this.pgErro = e?.message ?? 'Erro ao enviar para maquineta.';
    } finally {
      this.pgEnviandoMaquineta = false;
    }
  }

  async pgFinalizarMaquineta(): Promise<void> {
    this.pgShowMaquinetaModal = false;
    this.pgAguardandoMaquineta = false;
    // Recarrega dados e itens para continuar no step de pagamento
    await this.pgRecarregarDados();
    await this.pgCarregarItens();
  }

  // ── Vincular Adiantamento ───────────────────────────────────

  // Mesma abertura do "Pagar" (dados, itens, médicos): fechando o modal, a tela de
  // pagamento já está completa. O título só é gerado ao confirmar (pgConfirmarVinculacao),
  // porque ele fecha a conta como definitiva.
  async vincularDireto(conta: ContaPacienteResumo): Promise<void> {
    await this.iniciarPagamento(conta);
    if (this.pgDados && this.pagandoConta === conta) await this.pgAbrirVincularModal();
  }

  async pgAbrirVincularModal(): Promise<void> {
    if (!this.pgDados) return;
    this.pgShowVincularModal = true;
    this.pgBuscaAdiantamentos.parar();
    this.pgAdiantamentosSelecionados = new Set();
    this.pgAdiantamentosNovos = new Set();
    this.pgLoadingAdiantamentos = true;
    this.pgVinculando = false;
    this.pgVincularProgresso = '';
    this.pgVincularSucesso = false;
    this.pgVincularResumo = null;
    try {
      this.pgAdiantamentos = await this.atendimentoService.getAdiantamentosDisponiveis(this.pgDados.nrInternoConta);
    } catch {
      this.pgAdiantamentos = [];
    } finally {
      this.pgLoadingAdiantamentos = false;
    }
    if (this.pgShowVincularModal) this.pgBuscaAdiantamentos.iniciar();
  }

  async pgAtualizarAdiantamentos(): Promise<void> {
    if (this.pgAtualizandoAdiantamentos || this.pgBuscaAdiantamentos.bloqueioManual > 0) return;
    this.pgAtualizandoAdiantamentos = true;
    try {
      await this.pgBuscaAdiantamentos.atualizarAgora();
    } finally {
      this.pgAtualizandoAdiantamentos = false;
    }
    if (this.pgShowVincularModal && !this.pgVincularSucesso) this.pgBuscaAdiantamentos.iniciar();
    this.pgBuscaAdiantamentos.travarManual();
  }

  private pgAplicarAdiantamentos(lista: AdiantamentoDisponivel[]): void {
    if (!this.pgShowVincularModal || this.pgVinculando || this.pgVincularSucesso) return;
    const r = mesclarAdiantamentos(this.pgAdiantamentos, lista, this.pgAdiantamentosSelecionados);
    this.pgAdiantamentos = r.lista;
    this.pgAdiantamentosSelecionados = r.selecionados;
    if (r.novos.length) {
      this.pgAdiantamentosNovos = new Set(r.novos);
      if (this.pgDestaqueTimer) clearTimeout(this.pgDestaqueTimer);
      this.pgDestaqueTimer = setTimeout(() => this.pgAdiantamentosNovos = new Set(), ADIANT_DESTAQUE_MS);
    }
  }

  pgToggleAdiantamento(nrAdiantamento: number): void {
    if (this.pgAdiantamentosSelecionados.has(nrAdiantamento)) {
      this.pgAdiantamentosSelecionados.delete(nrAdiantamento);
    } else {
      this.pgAdiantamentosSelecionados.add(nrAdiantamento);
    }
  }

  pgIsAdiantamentoSelecionado(nrAdiantamento: number): boolean {
    return this.pgAdiantamentosSelecionados.has(nrAdiantamento);
  }

  get pgTotalAdiantamentosSelecionados(): number {
    return this.pgAdiantamentosSelecionados.size;
  }

  get pgValorAdiantamentosSelecionados(): number {
    return this.pgAdiantamentos
      .filter(a => this.pgAdiantamentosSelecionados.has(a.nrAdiantamento))
      .reduce((sum, a) => sum + a.vlSaldo, 0);
  }

  async pgConfirmarVinculacao(): Promise<void> {
    if (this.pgVinculando || this.pgAdiantamentosSelecionados.size === 0) return;
    if (!this.pgDados || !this.pagandoConta) return;
    this.pgBuscaAdiantamentos.parar();
    this.pgVinculando = true;
    this.pgErro = '';
    const selecionados = this.pgAdiantamentos.filter(a => this.pgAdiantamentosSelecionados.has(a.nrAdiantamento));
    let vinculados = 0;
    try {
      // Conta ainda sem título: gera agora, com a vinculação confirmada (fecha como definitiva).
      let nrTitulo = this.pgResultado?.nrTitulo || this.pgDados.nrTituloConta;
      if (!nrTitulo) {
        this.pgVincularProgresso = 'Gerando título da conta...';
        this.pgResultado = await this.atendimentoService.processarPagamento({
          nrInternoConta: this.pgDados.nrInternoConta,
          nrAtendimento: this.pagandoConta.nrAtendimento,
          cdPessoaFisica: this.detalhesPaciente!.cdPessoaFisica,
          cdEstabelecimento: Number(this.unitCode),
          nmUsuario: this.userName,
        });
        nrTitulo = this.pgResultado?.nrTitulo;
      }
      if (!nrTitulo) {
        this.pgErro = 'Não foi possível gerar o título da conta para vincular.';
        return;
      }
      for (const adian of selecionados) {
        vinculados++;
        this.pgVincularProgresso = `Vinculando ${vinculados}/${selecionados.length}...`;
        await this.atendimentoService.vincularAdiantamento({
          nrTitulo: nrTitulo,
          nrAdiantamento: adian.nrAdiantamento,
          nmUsuario: this.userName,
        });
      }
      // Se tem callback (pré-vincular → pagamento), fechar e executar
      if (this.pgVincularCallback) {
        this.pgShowVincularModal = false;
        const cb = this.pgVincularCallback;
        this.pgVincularCallback = null;
        await cb();
        return;
      }
      // Pós-vincular: recarregar dados e mostrar tela de sucesso
      const vlVinculado = this.pgValorAdiantamentosSelecionados;
      if (this.pagandoConta && this.detalhesPaciente) {
        this.pgDados = await this.atendimentoService.getDadosPagamento(
          this.pagandoConta.nrAtendimento, this.detalhesPaciente.cdPessoaFisica);
      }
      this.pgVincularResumo = {
        nrTitulo: nrTitulo,
        vlVinculado: vlVinculado,
        vlSaldoPendente: this.pgDados?.vlSaldo ?? 0,
      };
      this.pgVincularSucesso = true;
    } catch (e: any) {
      this.pgErro = e?.message ?? 'Erro ao vincular adiantamento.';
      this.pgBuscaAdiantamentos.iniciar();
    } finally {
      this.pgVinculando = false;
      this.pgVincularProgresso = '';
    }
  }

  pgFecharVincularModal(): void {
    const houveSucesso = this.pgVincularSucesso;
    this.pgBuscaAdiantamentos.parar();
    this.pgShowVincularModal = false;
    this.pgVincularSucesso = false;
    this.pgVincularResumo = null;
    // Se cancelou o pré-vincular, processar pagamento mesmo assim
    if (this.pgVincularCallback) {
      const cb = this.pgVincularCallback;
      this.pgVincularCallback = null;
      cb();
    }
    // Se veio do vincularDireto e teve sucesso, recarregar contas
    if (houveSucesso && this.detalhesPaciente) {
      this.atendimentoService.getContasPaciente(this.detalhesPaciente.cdPessoaFisica)
        .then(c => this.contasPaciente = c)
        .catch(() => {});
    }
  }

  async pgVerFichaPdf(): Promise<void> {
    if (!this.pgDados) return;
    const ficha = await this.atendimentoService.getFichaAtendimento(this.pgDados.nrInternoConta);
    if (!ficha) { this.pgErro = 'Erro ao carregar ficha.'; return; }
    let barcodeDataUrl = '';
    try {
      const JsBarcode = (await import('jsbarcode')).default;
      const canvas = document.createElement('canvas');
      JsBarcode(canvas, String(ficha.nrAtendimento), {
        format: 'CODE128', width: 1, height: 40, displayValue: false, margin: 0
      });
      barcodeDataUrl = canvas.toDataURL();
    } catch { /* silencioso */ }
    this.pgImprimirFicha(ficha, barcodeDataUrl);
  }

  private pgImprimirFicha(f: any, barcodeDataUrl: string = ''): void {
    const fc = (v: number) => v != null ? v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '';
    const logo = fichaLogoHtml(this.brandService.logo);
    const titulo = fichaTitulo(this.brandService.brandName);
    // Agrupar procedimentos por médico executor (igual ao PRE)
    const gruposMap = new Map<string, { nmMedico: string; procs: any[] }>();
    for (const proc of (f.procedimentos || [])) {
      const key = proc.nmMedicoExecutor || '__SEM_EXECUTOR__';
      if (!gruposMap.has(key)) {
        gruposMap.set(key, { nmMedico: proc.nmMedicoExecutor || f.nmMedico || '', procs: [] });
      }
      gruposMap.get(key)!.procs.push(proc);
    }
    const gruposArr = [...gruposMap.values()];
    if (gruposArr.length === 0) gruposArr.push({ nmMedico: f.nmMedico || '', procs: [] });

    const renderPagina = (grupo: { nmMedico: string; procs: any[] }, isFirst: boolean) => {
      const pageBreak = isFirst ? '' : 'page-break-before:always;';
      const procsHtml = grupo.procs.map((p: any) => `<tr><td class="col-codigo">${p.cdProcedimento||''}</td><td class="col-desc">${p.dsProcedimento||''}</td><td class="col-qtd">${p.qtProcedimento||''}</td><td class="col-vlprazo">${fc(p.vlPrazo)}</td><td class="col-vlvista"></td><td class="col-dtexec"></td><td class="col-obs"></td><td class="col-lado"></td></tr>`).join('');
      return `<div style="${pageBreak}"><div class="header-container"><div class="header-left"><div class="logo">${logo}</div></div><div class="header-title"><h1>${titulo}</h1><h2>Exames/Procedimentos</h2></div><div class="barcode-right">${barcodeDataUrl?'<img src="'+barcodeDataUrl+'" alt="Barcode" />':''}</div></div><table class="info-table"><tr><td class="label">Prontuário</td><td>${f.nrProntuario||''}</td><td class="label">Atendimento</td><td>${f.nrAtendimento||''}</td><td class="label">Prescrição</td><td>${f.nrPrescricao||''}</td><td class="label">Data Entrada</td><td>${f.dtEntrada||''}</td></tr><tr><td class="label">Paciente</td><td colspan="3">${f.nmPaciente||''}</td><td class="label">CPF</td><td>${f.cpf||''}</td><td class="label">Telefone</td><td>${f.telefone||''}</td></tr><tr><td class="label">Data Nascto</td><td>${f.dtNascimento||''}</td><td class="label">Idade</td><td>${f.dsIdade||''}</td><td class="label">Sexo</td><td colspan="3">${f.dsSexo||''}</td></tr><tr><td class="label">Endereço</td><td colspan="3">${f.dsEndereco||''}</td><td class="label">Nº</td><td>${f.nrEndereco||''}</td><td class="label">Data Entrega</td><td>${f.dtEntrega||''}</td></tr><tr><td class="label">Convênio</td><td colspan="3">${f.nmConvenio||''}</td><td class="label">Bairro</td><td>${f.bairro||''}</td><td class="label">Usuário Aten.</td><td>${f.nmUsuarioAtend||''}</td></tr><tr><td class="label">Setor</td><td>${f.dsSetorLeito||''}</td><td class="label">CEP</td><td>${f.cep||''}</td><td class="label">Data Lib.</td><td colspan="3">${f.dtLiberacao||''}</td></tr><tr><td class="label"></td><td></td><td class="label"></td><td></td><td class="label">Estado</td><td>${f.estado||''}</td><td class="label">Estab.</td><td>${f.estabelecimento||''}</td></tr><tr><td class="label">E-mail:</td><td colspan="3">${f.email||''}</td><td class="label"></td><td></td><td class="label">CNPJ:</td><td>${f.cnpj||''}</td></tr></table><div class="responsavel-row"><span class="field"><span class="label">Responsável:</span> ${f.nmResponsavel||''}</span><span class="field"><span class="label">CPF:</span> ${f.cpfResponsavel||''}</span><span class="field"><span class="label">E-mail:</span> ${f.emailResponsavel||''}</span></div><div class="section-title">Atendimento Atual</div><div class="atendimento-box"><div class="atendimento-field"><span class="label">Médico:</span> ${grupo.nmMedico}</div><div class="atendimento-field"><span class="label">Forma de Entrega do Laudo:</span></div><div class="atendimento-field"><span class="label">Diagnóstico:</span></div></div>${procsHtml?'<div class="exames-title">Exames Solicitados</div><table class="proc-table"><thead><tr><th class="col-codigo">Código</th><th class="col-desc">Descrição</th><th class="col-qtd">Qtde.</th><th class="col-vlprazo">Vl a prazo</th><th class="col-vlvista">Vl a vista</th><th class="col-dtexec">Data e Hora Exec.</th><th class="col-obs">Observação</th><th class="col-lado">Lado</th></tr></thead><tbody>'+procsHtml+'</tbody></table>':''}<div class="footer"><p><strong>Impresso por:</strong> ${this.userName} | <strong>Data/Hora:</strong> ${new Date().toLocaleString('pt-BR')} | <strong>Estabelecimento:</strong> ${f.estabelecimento||'N/A'}</p></div></div>`;
    };
    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>${titulo}</title><style>body{font-family:Arial,sans-serif;margin:20px;font-size:9px;color:#000}*{-webkit-print-color-adjust:exact !important;print-color-adjust:exact !important}@media print{body{margin:10px}@page{size:A4;margin:20px}}.header-container{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:10px}.header-left{display:flex;align-items:center}.header-left .logo{margin-right:20px}.header-left .logo svg{height:50px;width:auto}.header-left .logo img{height:50px;width:auto}.header-title{text-align:center;flex-grow:1}.header-title h1{font-size:16px;font-weight:bold;margin:0}.header-title h2{font-size:11px;margin:3px 0 0 0;font-weight:normal}.barcode-right{text-align:right}.barcode-right img{height:35px}.info-table{width:100%;border-collapse:collapse;margin-bottom:8px;border:1px solid #000}.info-table td{padding:3px 5px;vertical-align:middle;font-size:9px;border:1px solid #000}.info-table .label{font-weight:bold;background-color:#e8e8e8;padding:3px 5px}.responsavel-row{margin-bottom:10px;padding:3px 5px;border:1px solid #000;background-color:#f5f5f5}.responsavel-row .field{display:inline-block;margin-right:40px}.responsavel-row .label{font-weight:bold}.section-title{font-weight:bold;text-align:center;padding:5px;border-top:1px solid #000;border-bottom:1px solid #000;margin:10px 0 5px 0;font-size:10px;background-color:#f5f5f5}.atendimento-box{border:1px solid #000;padding:8px;margin-bottom:8px}.atendimento-field{margin-bottom:3px}.atendimento-field .label{font-weight:bold}.exames-title{font-weight:bold;text-align:center;padding:5px;border-top:1px solid #000;border-bottom:1px solid #000;margin:10px 0 5px 0;font-size:10px;background-color:#f5f5f5}.proc-table{width:100%;border-collapse:collapse;margin-top:5px}.proc-table th{background-color:#e8e8e8;border:1px solid #000;padding:3px 5px;font-size:8px;text-align:left;font-weight:bold}.proc-table td{border:1px solid #000;padding:3px 5px;font-size:8px;vertical-align:top}.proc-table .col-codigo{width:70px}.proc-table .col-qtd{width:35px;text-align:center}.proc-table .col-vlprazo{width:60px;text-align:right}.proc-table .col-vlvista{width:60px;text-align:right}.proc-table .col-dtexec{width:110px;text-align:center}.proc-table .col-obs{width:80px}.proc-table .col-lado{width:40px;text-align:center}.footer{margin-top:30px;padding-top:10px;border-top:1px solid #000;text-align:center;font-size:8px;color:#666}.footer p{margin:0}</style></head><body>${gruposArr.map((g,i)=>renderPagina(g,i===0)).join('')}</body></html>`;
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.top = '-10000px';
    iframe.style.left = '-10000px';
    iframe.style.width = '0';
    iframe.style.height = '0';
    document.body.appendChild(iframe);
    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      doc.write(html);
      doc.close();
      setTimeout(() => {
        iframe.contentWindow?.print();
        setTimeout(() => document.body.removeChild(iframe), 1000);
      }, 500);
    }
  }

  async verFichaMeuAtendimento(a: MeuAtendimento): Promise<void> {
    try {
      const dados = await this.atendimentoService.getDadosPagamento(a.nrAtendimento, a.cdPessoaFisica);
      if (!dados) return;
      const ficha = await this.atendimentoService.getFichaAtendimento(dados.nrInternoConta);
      if (!ficha) return;
      let barcodeDataUrl = '';
      try {
        const JsBarcode = (await import('jsbarcode')).default;
        const canvas = document.createElement('canvas');
        JsBarcode(canvas, String(ficha.nrAtendimento), {
          format: 'CODE128', width: 1, height: 40, displayValue: false, margin: 0
        });
        barcodeDataUrl = canvas.toDataURL();
      } catch {}
      this.pgImprimirFicha(ficha, barcodeDataUrl);

      const tcles = matchTcles(ficha.procedimentos ?? []);
      tcles.forEach((tcle, i) => {
        setTimeout(() => {
          const handled = tcle.key ? imprimirTcle(tcle.key as TcleKey, ficha, this.userName, { logo: this.brandService.logo, cdEmpresa: this.brandService.cdEmpresa }) : false;
          if (!handled) window.open(urlTcle(tcle.driveId), '_blank');
        }, 800 + i * 800);
      });
    } catch {}
  }

  pgSumAdianOriginal(): number {
    return this.pgResumo?.adiantamentosAplicados?.reduce((acc, a) => acc + (a.vlOriginal || 0), 0) ?? 0;
  }

  pgSumAdianSaldoAtual(): number {
    return this.pgResumo?.adiantamentosAplicados?.reduce((acc, a) => acc + (a.vlSaldoAtual || 0), 0) ?? 0;
  }

  pgCopiarValor(campo: string, valor: any): void {
    navigator.clipboard.writeText(String(valor ?? '')).then(() => {
      this.pgCopiadoCampo = campo;
      setTimeout(() => this.pgCopiadoCampo = '', 2000);
    });
  }

  private async pgRecarregarDados(): Promise<void> {
    if (!this.pagandoConta || !this.detalhesPaciente) return;
    try {
      this.pgDados = await this.atendimentoService.getDadosPagamento(
        this.pagandoConta.nrAtendimento, this.detalhesPaciente.cdPessoaFisica);
    } catch { /* silencioso */ }
  }

  // Orçamento
  async pgAbrirOrcamentoModal(): Promise<void> {
    this.pgShowOrcamentoModal = true;
    if (this.pgOrcamentoGroups.length > 0) return;
    this.pgLoadingOrcamentos = true;
    try {
      const items = await this.atendimentoService.getOrcamentos(this.detalhesPaciente!.cdPessoaFisica);
      this.pgOrcamentoGroups = this.pgAgruparOrcamentos(items);
    } catch {
      this.pgOrcamentoGroups = [];
    } finally {
      this.pgLoadingOrcamentos = false;
    }
  }

  private pgAgruparOrcamentos(items: OrcamentoItem[]): OrcamentoGroup[] {
    const map = new Map<number, OrcamentoGroup>();
    for (const item of items) {
      if (!map.has(item.nrSequenciaOrcamento)) {
        map.set(item.nrSequenciaOrcamento, {
          nrSequenciaOrcamento: item.nrSequenciaOrcamento,
          dtOrcamento: item.dtOrcamento,
          procedimentos: [],
          totalCartao: 0,
          totalVista: 0,
        });
      }
      const group = map.get(item.nrSequenciaOrcamento)!;
      group.procedimentos.push({ ...item, selecionado: false });
      group.totalCartao += item.vlCartao * item.qtProcedimento;
      group.totalVista += item.vlVista * item.qtProcedimento;
    }
    return Array.from(map.values());
  }

  get pgIsParticular(): boolean {
    return this.selectedCallPassword?.planDescription?.toUpperCase() === 'PARTICULAR';
  }

  pgToggleTodosOrcamento(group: OrcamentoGroup): void {
    const todos = group.procedimentos.every(p => p.selecionado);
    group.procedimentos.forEach(p => p.selecionado = !todos);
  }

  pgTodosSelecionados(group: OrcamentoGroup): boolean {
    return group.procedimentos.length > 0 && group.procedimentos.every(p => p.selecionado);
  }

  get pgTotalSelecionadosOrcamento(): number {
    return this.pgOrcamentoGroups.reduce(
      (acc, g) => acc + g.procedimentos.filter(p => p.selecionado).length, 0);
  }

  async pgInserirSelecionadosOrcamento(): Promise<void> {
    if (!this.pagandoConta || !this.detalhesPaciente) return;
    this.pgInserindoOrcamento = true;
    this.pgErro = '';
    try {
      const atendOrc = this.meusAtendimentos.find(a => a.nrAtendimento === this.pagandoConta!.nrAtendimento);
      for (const group of this.pgOrcamentoGroups) {
        for (const proc of group.procedimentos) {
          if (!proc.selecionado) continue;
          await this.atendimentoService.adicionarProcedimentoConta({
            nrAtendimento: this.pagandoConta.nrAtendimento,
            cdPessoaFisica: this.detalhesPaciente.cdPessoaFisica,
            cdEstabelecimento: Number(this.unitCode),
            cdMedico: atendOrc?.cdMedicoResp ?? 0,
            cdSetorAtendimento: 0,
            cdProcedimento: proc.cdProcedimento,
            nrSequenciaProc: proc.nrSequencia,
            ieOrigemProced: proc.ieOrigemProced ?? 'P',
            quantidade: proc.qtProcedimento,
            nmUsuario: this.userName,
          });
        }
      }
      this.pgShowOrcamentoModal = false;
      await this.pgRecarregarDados();
      await this.pgCarregarItens();
      this.pgShowItens = true;
    } catch (e: any) {
      this.pgErro = e?.message ?? 'Erro ao adicionar procedimentos do orçamento.';
    } finally {
      this.pgInserindoOrcamento = false;
    }
  }

  // ── Score de exibição (coluna "Peso") ────────────────────────────────────

  getDashFilaConfig(): FilaConfig {
    if (this._cachedFilaConfig) return this._cachedFilaConfig;
    this._cachedFilaConfig = parseFilaConfig(localStorage.getItem('gerenciar-fila-order'));
    return this._cachedFilaConfig;
  }

  qualificaDash(p: PasswordDTO, key: string): boolean {
    return qualificaGrupo(p, key, Date.now());
  }

  calcScoreForDisplay(p: PasswordDTO): number {
    return calcScoreFila(p, this.getDashFilaConfig(), Date.now());
  }

  estourou(p: PasswordDTO): boolean {
    return estourouEspera(p, this.getDashFilaConfig(), Date.now());
  }

  getDashQualifyingGroups(p: PasswordDTO): { config: GrupoConfig; weight: number; fator: number }[] {
    const cfg = this.getDashFilaConfig();
    const now = Date.now();
    return cfg.order
      .filter(k => qualificaGrupo(p, k, now))
      .map(k => {
        const fator = fatorPesoEscalonado(k, p.planType, esperaMs(p, now));
        return { config: GRUPOS_DEF.find(g => g.key === k)!, weight: pesoGrupo(k, cfg) * fator, fator };
      });
  }

  trackByPasswordId(_: number, p: PasswordDTO): number { return p.id; }

  showDashScoreTooltip(event: MouseEvent, p: PasswordDTO): void {
    if (this._tooltipHideTimer) { clearTimeout(this._tooltipHideTimer); this._tooltipHideTimer = null; }
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const groups = this.getDashQualifyingGroups(p);
    this.scoreTooltipDash = { x: rect.left, y: rect.bottom + 6, groups, total: this.calcScoreForDisplay(p) };
    this.cdr.detectChanges();
  }

  hideDashScoreTooltip(): void {
    this._tooltipHideTimer = setTimeout(() => {
      this.scoreTooltipDash = null;
      this.cdr.detectChanges();
    }, 120);
  }

  keepDashTooltipOpen(): void {
    if (this._tooltipHideTimer) { clearTimeout(this._tooltipHideTimer); this._tooltipHideTimer = null; }
  }
}
